var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "background-simple",
    "data-motion": "blob",
    "data-delay": 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600.07,108.44l-2.75-4.53c-23.18-38.19-65.09-61.22-109.27-58.43a115.13,115.13,0,0,0-16.92,2.33c-40.17,8.6-75.13,39-89.62,77.88-8.52,22.88-10.9,49.23-27.07,67.39-21,23.64-56.77,24.38-88.19,23.4s-67.16-.14-88.11,23.59c-13.11,14.86-17.28,36-16.22,55.9,2.8,52.7,39.52,99.82,86.21,123.24s101.68,25.51,152.79,15.21c71.6-14.43,139.69-54.07,180.61-115.28S632.81,174.52,600.07,108.44Z",
    style: {
      fill: "#F0F5FA"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "character",
    "data-motion": "breathe",
    "data-delay": 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M518.85,87.73c1.45-11.76,13.89-20.34,25.7-19.35s22,10,26.4,21c2.16,5.41,3.09,11.57,1.15,17.06-2.05,5.78-7.08,10.14-12.71,12.57a31,31,0,0,1-43-32.83",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.91,77.17a4.31,4.31,0,0,1-.39,1.61,25.78,25.78,0,0,1-1.83,4.12,31.77,31.77,0,0,1-23.86,16.26,26.41,26.41,0,0,1-4.51.2,4.49,4.49,0,0,1-1.64-.23c0-.19,2.35-.1,6-.75A33.9,33.9,0,0,0,560,82.51C562,79.32,562.73,77.1,562.91,77.17Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.78,88c.06,0-.25.56-.87,1.44A40.4,40.4,0,0,1,567.05,93a42.13,42.13,0,0,1-11.84,9.29,34.47,34.47,0,0,1-7.84,2.83,31,31,0,0,1-6.77.7,24.48,24.48,0,0,1-4.55-.41,4.89,4.89,0,0,1-1.63-.42c0-.21,2.38.19,6.16,0a34.73,34.73,0,0,0,6.56-.92,36.31,36.31,0,0,0,7.57-2.82,47.86,47.86,0,0,0,11.77-8.83C569.15,89.71,570.63,87.86,570.78,88Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.58,149.68c-40.69-48.89,12-93.49,47.53-93.21,33.37.26,50.8,12.06,61.57,31.38s16.68,41.84,14,63.8c-1.34,10.83-5.85,22.69-16,26.77",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.46,91l-2.17-10.32L442.9,83.16c-19.49,2.37-35.66,26.18-32.47,45.54,3.56,21.52,8.74,47.65,14.9,62.9C437.72,222.26,463,220.68,463,220.68l7.42,31.56L541,236.9Z",
    style: {
      fill: "#ffd1bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.73,150.9a4.19,4.19,0,0,0,4.89,3.21,4,4,0,0,0,3.36-4.65,4.19,4.19,0,0,0-4.88-3.21A4,4,0,0,0,423.73,150.9Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.69,141c.49.37,3.74-.44,8.19.21s7.62,2.35,8.13,2.12c.25-.1-.23-.71-1.6-1.48a19.47,19.47,0,0,0-6.48-2.06,17.58,17.58,0,0,0-6.55.2C420,140.38,419.45,140.84,419.69,141Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.63,142.2a4.19,4.19,0,0,0,4.88,3.21,4,4,0,0,0,3.36-4.65,4.2,4.2,0,0,0-4.88-3.22A4,4,0,0,0,464.63,142.2Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.65,135.69c.6,0,2.75-2.54,6.7-4.69s7.46-2.78,7.74-3.25c.14-.22-.58-.39-2.13-.14a20.84,20.84,0,0,0-6.38,2.31,18.15,18.15,0,0,0-5.15,4C462.5,135.06,462.36,135.71,462.65,135.69Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.2,167.78c0-.25-2.87-.09-7.43.36-1.14.14-2.26.16-2.62-.56s-.26-2.06,0-3.49l1.35-9.31c1.8-13.22,2.83-24,2.3-24.05s-2.43,10.59-4.23,23.81q-.63,4.88-1.2,9.32c-.13,1.38-.53,3,.43,4.54a2.87,2.87,0,0,0,2.23,1.21,7.73,7.73,0,0,0,2-.17C452.48,168.65,455.24,168,455.2,167.78Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.08,220.76s22.79-3.87,41.06-21.5c0,0-5.61,24.76-39.22,29.43Z",
    style: {
      fill: "#cc8f75"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.5,177.94a8.14,8.14,0,0,1,6.42-4.58,7.4,7.4,0,0,1,5.6,1.53,4.69,4.69,0,0,1,1.56,5.15c-.8,1.94-3.19,2.9-5.43,2.79a17.19,17.19,0,0,1-6.38-2.06,5.11,5.11,0,0,1-1.56-1,1.5,1.5,0,0,1-.36-1.63",
    style: {
      fill: "#cc8f75"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.53,114.59c.71,1.1,5-.48,10.26-1s9.79-.12,10.22-1.35c.19-.58-.79-1.54-2.74-2.3a17,17,0,0,0-8-.89,17.15,17.15,0,0,0-7.59,2.71C459,112.91,458.22,114.07,458.53,114.59Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,127.59c1,.82,3.79-.91,7.42-1.8s6.87-.88,7.34-2.09c.19-.57-.52-1.46-2.09-2.09a11,11,0,0,0-11.89,3.13C418.69,126.06,418.51,127.18,419,127.59Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.69,173.05c.34.65-2.78,2.9-6.35,5.88s-6.37,5.6-7,5.14,1.46-4,5.3-7.15S473.38,172.42,473.69,173.05Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.32,130.82c.38-.33,14.07-11.49,19.16,6.38s-13.9,19.29-14.07,18.79S510.32,130.82,510.32,130.82Z",
    style: {
      fill: "#ffd1bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.93,147.66c.07-.08.38.13,1,.22a3.24,3.24,0,0,0,2.34-.61c1.69-1.23,2.43-4.68,1.6-7.93a10.71,10.71,0,0,0-2.14-4.2,3.73,3.73,0,0,0-3-1.72,1.65,1.65,0,0,0-1.59,1.37c-.1.57.12.89,0,1s-.47-.19-.53-1a2.07,2.07,0,0,1,.38-1.32,2.42,2.42,0,0,1,1.59-.94,4.52,4.52,0,0,1,4,1.84,10.9,10.9,0,0,1,2.5,4.67c.91,3.64,0,7.53-2.34,9a3.44,3.44,0,0,1-3,.34C519.09,148.09,518.88,147.71,518.93,147.66Z",
    style: {
      fill: "#cc8f75"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.39,71.69a7.06,7.06,0,0,0-2.64-.85c-11.41-2-23.46-1-34.06,3.66S416,87.65,411.49,98.31s-8.7,27.29-3,37.38l4.51,7.67c-1.08-7.82.57-22.64,3.7-29.89a32.06,32.06,0,0,1,16-16.7c7.23-3.21,15.43-3.2,23.17-4.86S471.78,86,474,78.41C474.65,76,474.46,73,472.39,71.69Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.29,126.7a4.14,4.14,0,0,1-.62-.88,18,18,0,0,1-1.4-2.74,26.13,26.13,0,0,1-1.95-11.15A30,30,0,0,1,407.63,96,38.82,38.82,0,0,1,423.46,83a52.7,52.7,0,0,1,20.06-4.54,73,73,0,0,1,9,.23c2.81.24,5.38.65,7.72.64,4.66-.3,8.58-.78,10.89-2a8,8,0,0,0,3-2.66,2.83,2.83,0,0,1-.48,1,6.46,6.46,0,0,1-2.32,2.07c-2.42,1.37-6.3,2-11.09,2.37-2.43.06-5-.31-7.81-.5a73.88,73.88,0,0,0-8.87-.13A53.07,53.07,0,0,0,423.92,84a38.51,38.51,0,0,0-15.45,12.64A29.71,29.71,0,0,0,403.1,112a27.23,27.23,0,0,0,1.57,11C405.59,125.39,406.39,126.65,406.29,126.7Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.5,70.57a6.57,6.57,0,0,1,1.79-.88,27.21,27.21,0,0,1,5.23-1.44,31.61,31.61,0,0,1,17.66,2c3.23,1.39,6.07,3.06,8.86,4a19.79,19.79,0,0,0,7.68.9,16.45,16.45,0,0,0,5.14-1c1.15-.47,1.67-1,1.73-.89s-.39.65-1.54,1.28A14.52,14.52,0,0,1,467.78,76a19.39,19.39,0,0,1-8.07-.71c-2.93-.94-5.83-2.62-9-4A33,33,0,0,0,433.64,69C429.18,69.63,426.57,70.77,426.5,70.57Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.11,71.69c-1.91,5.76-3.83,11.62-4,17.68s1.76,12.47,6.38,16.4c4.42,3.77,10.49,4.71,16.14,6.06s11.7,3.64,14.42,8.78c.85,1.6,1.76,7.77,3.37,8.61,2.21,1.16,5-.7,5.82-3.06s-.14-9.17-.77-11.58c-1.94-7.49-2.54-18.82-4.48-26.31-1.64-6.33-4.85-9-9.14-14-6-6.91-14.64-7.28-26.05-3.55",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.15,100.7c-.09.07-.61-.6-1.79-1.51a13.28,13.28,0,0,0-5.76-2.35,20.94,20.94,0,0,0-9.23.64A70,70,0,0,0,504.73,102a42.45,42.45,0,0,1-11.09,4,32.14,32.14,0,0,1-9.63.29,29,29,0,0,1-6.32-1.45,7.7,7.7,0,0,1-2.17-1c.07-.21,3.2,1.18,8.57,1.65a33.52,33.52,0,0,0,9.36-.52,43.35,43.35,0,0,0,10.8-3.95,65.43,65.43,0,0,1,10.84-4.55,21,21,0,0,1,9.65-.42,12.67,12.67,0,0,1,5.89,2.79,8.47,8.47,0,0,1,1.2,1.31C532.07,100.49,532.18,100.68,532.15,100.7Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525,87.22c-.08.06-.59-.59-1.77-1.45a12.49,12.49,0,0,0-5.71-2.06,18.5,18.5,0,0,0-8.89,1.45c-3.24,1.23-6.54,3.22-10.22,5s-7.54,3-11.2,2.88a18.71,18.71,0,0,1-9.06-2.68,17.29,17.29,0,0,1-4.81-4.17,10.06,10.06,0,0,1-1-1.42c-.2-.35-.29-.53-.26-.56.19-.18,1.82,2.92,6.43,5.47a18.57,18.57,0,0,0,8.7,2.34c3.42.11,7.09-1.1,10.69-2.85s7-3.74,10.33-5a18.69,18.69,0,0,1,9.36-1.27,11.88,11.88,0,0,1,5.87,2.5A5,5,0,0,1,525,87.22Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.53,139.59l.05.17.13.5c.12.46.28,1.11.5,2,.44,1.73,1.08,4.28,2,7.55s2,7.27,3.47,11.84a41.94,41.94,0,0,0,2.86,7.11c.18.27.36.56.55.83s.45.52.71.75a11.06,11.06,0,0,0,1.63,1.32,13.66,13.66,0,0,0,4,1.8,19,19,0,0,0,9.31,0,14,14,0,0,0,4.59-1.88A14.56,14.56,0,0,0,439,168a25.83,25.83,0,0,0,4.24-10,10.68,10.68,0,0,1,.83-2.8,4.81,4.81,0,0,1,2-2.24,3.42,3.42,0,0,1,3,.11,7.77,7.77,0,0,1,2.4,1.89c.71.72,1.26,1.63,1.9,2.37a11.67,11.67,0,0,0,2.15,2.06,21.31,21.31,0,0,0,5.44,2.83,38.81,38.81,0,0,0,12.5,2.19A36.74,36.74,0,0,0,480,164a14.48,14.48,0,0,0,1.62-.31c.53-.14,1.09-.22,1.61-.4l1.58-.5c.5-.23,1-.42,1.5-.69a77.17,77.17,0,0,0,11.09-7.9c2.75-2.24,5.42-4.53,8-6.84l-.07.26c-2.72-9.73-5.33-19.11-7.79-27.93l.29.18-66.15,14.21-19.2,4.09-5.15,1.08-1.34.28-.46.08.43-.11,1.3-.29,5.08-1.14,19.12-4.21,66.26-14.48.23,0,.07.23c2.46,8.82,5.09,18.2,7.81,27.92l0,.15-.12.11c-2.59,2.33-5.27,4.61-8,6.87a78.91,78.91,0,0,1-11.18,7.95c-.5.28-1,.48-1.56.71l-1.62.52c-.53.18-1.09.26-1.64.4a15,15,0,0,1-1.65.32,37.75,37.75,0,0,1-6.61.46,39.31,39.31,0,0,1-12.66-2.23,21.64,21.64,0,0,1-5.56-2.9,12.73,12.73,0,0,1-2.24-2.16c-.68-.8-1.18-1.64-1.87-2.35a7.54,7.54,0,0,0-2.25-1.79,3,3,0,0,0-2.63-.11,4.38,4.38,0,0,0-1.8,2,10.69,10.69,0,0,0-.79,2.69,26.2,26.2,0,0,1-4.34,10.17,15.24,15.24,0,0,1-3.84,3.64,14.3,14.3,0,0,1-4.73,1.92,19.18,19.18,0,0,1-9.5-.07,13.85,13.85,0,0,1-4.07-1.86,11.08,11.08,0,0,1-1.67-1.37c-.26-.24-.48-.52-.72-.77s-.39-.59-.59-.88a42.05,42.05,0,0,1-2.85-7.19c-1.48-4.59-2.52-8.6-3.38-11.88s-1.47-5.84-1.87-7.58q-.3-1.29-.45-2l-.11-.51A1.2,1.2,0,0,1,405.53,139.59Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.43,169c-.14,0-1.8-5.91-3.72-13.27s-3.36-13.37-3.22-13.41,1.8,5.91,3.72,13.28S415.57,168.92,415.43,169Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.58,145.87c.13.06-1.69,4.6-4.08,10.15s-4.43,10-4.56,9.95,1.69-4.6,4.08-10.16S439.45,145.81,439.58,145.87Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.81,139.24a15.74,15.74,0,0,1-.87,2.89c-.62,1.76-1.54,4.17-2.64,6.79s-2.19,5-3,6.62a17.06,17.06,0,0,1-1.45,2.65,17.71,17.71,0,0,1,1.12-2.8l2.87-6.68,2.77-6.71A18.87,18.87,0,0,1,444.81,139.24Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490,129a4.32,4.32,0,0,1-.36,1c-.26.61-.65,1.49-1.14,2.58-1,2.17-2.37,5.14-3.94,8.42-2.51,5.26-4.71,9.69-5.52,11.15l-.28.5.13-.55a2.07,2.07,0,0,1,.2-.69,3,3,0,0,1,0,.72l-.16-.05c.63-1.55,2.69-6,5.2-11.3,1.57-3.28,3-6.23,4.08-8.36.53-1.07,1-1.92,1.29-2.51A3.52,3.52,0,0,1,490,129Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.94,132.9a96.72,96.72,0,0,1-4.08,9.14A97.46,97.46,0,0,1,483.3,151a96.72,96.72,0,0,1,4.09-9.14A96,96,0,0,1,491.94,132.9Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.5,159.55a5.9,5.9,0,0,1-1.08.67,10.75,10.75,0,0,1-1.33.68c-.53.23-1.13.53-1.82.76a23,23,0,0,1-2.29.73,25.62,25.62,0,0,1-2.69.6,30.94,30.94,0,0,1-6.29.36,31.44,31.44,0,0,1-6.23-1,26.59,26.59,0,0,1-2.61-.87,18.85,18.85,0,0,1-2.19-1,16.1,16.1,0,0,1-1.74-.94,11.42,11.42,0,0,1-1.25-.81,4.92,4.92,0,0,1-1-.78c.06-.09,1.51,1,4.14,2.2a23.12,23.12,0,0,0,2.19.89c.79.32,1.67.55,2.59.82a32.82,32.82,0,0,0,6.13,1,33.28,33.28,0,0,0,6.19-.31c.94-.18,1.84-.31,2.65-.55a20.08,20.08,0,0,0,2.27-.66C485.88,160.38,487.45,159.45,487.5,159.55Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.58,147.53a2.53,2.53,0,0,1-.17-.49l-.44-1.48c-.4-1.36-1-3.26-1.64-5.62-1.41-4.91-3.36-11.73-5.61-19.62l-.13-.44.44.13,10.87,3.21,8.18,2.43.15,0,0,.14c1.15,5.4,2.21,10.36,3.12,14.61l0,.17-.15.07-10.74,5-2.93,1.36-.76.34-.25.1.27-.16.78-.4,2.94-1.47,10.51-5.19-.11.23c-.94-4.25-2-9.2-3.21-14.59l.18.19-8.18-2.42-10.88-3.23.32-.31,5.32,19.51c.64,2.41,1.16,4.34,1.53,5.72.16.65.3,1.16.4,1.55S505.58,147.51,505.58,147.53Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.53 140.52 404.31 135.35 497.05 114.88 498.5 120.72 405.53 140.52",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "497.05 114.88 516.25 121.36 517.46 126.45 498.5 120.72 497.05 114.88",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431.11 247.35 458.77 237.8 539.16 215.49 611.51 236.8 611.51 378.14 599.76 468.84 438.06 468.46 441.27 415.83 431.11 247.35",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.92,468.54s0-.23,0-.66.1-1.09.17-1.93c.17-1.71.41-4.2.72-7.41.66-6.44,1.6-15.74,2.77-27.22,2.37-23,5.67-54.75,9.58-89.79q1-8.37,1.89-16.47c.65-5.38,1.27-10.67,2.06-15.8,1.72-10.25,4-19.85,6.09-28.77,4.26-17.82,8.24-32.83,11.2-43.73v.09l-5.19-14.36-1.34-3.8-.32-1a3.45,3.45,0,0,1-.09-.34l7.21,19.38,0,0,0,.05c-2.88,10.91-6.81,25.93-11,43.75-2.07,8.92-4.32,18.53-6,28.75-.79,5.11-1.4,10.4-2,15.78s-1.25,10.89-1.89,16.47c-3.91,35-7.27,66.79-9.74,89.76-1.23,11.48-2.23,20.77-2.92,27.22-.36,3.19-.63,5.68-.82,7.39-.1.83-.17,1.47-.23,1.92S470.92,468.54,470.92,468.54Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "455.14 336.67 445.89 409.61 489.32 419.22 500.03 340.25 455.14 336.67",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.64,339.87c-.19.56-8.51,66.34-7.94,66.53s35.54,7.41,35.54,7.41l10.57-70.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.66,414.41l-.52-.11c-3.58-.74-35-7.23-35.6-7.43l-.2-.06-.1-.2c-.13-.26-.37-.74,3.68-33.68,1.76-14.32,4.11-32.83,4.24-33.22l.13-.38,39.09,3.44-.08.53ZM450.17,406c2.83.63,23.23,4.85,34.65,7.21l10.41-69.53-37.17-3.27C457.34,345.79,450.29,401.14,450.17,406Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.14,336.67s7.36-1.49,8.4-6l26.92,1.17a15.25,15.25,0,0,0,9.57,8.42Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475.98 306.84 475.98 325.36 482.17 325.36 483.13 306.84 475.98 306.84",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "540.12 217.37 536.76 206.83 460.67 228.1 463.51 238.48 474.97 270.41 549.37 235.29 540.12 217.37",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.67,238.48c0,1.06,22.31,68.36,22.31,68.36h7.15l70.75-87-8.34-2.45L480.2,299.6l-18.83-62.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "485.28 318.01 483.22 334.42 474.06 333.7 473.73 318.01 485.28 318.01",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.51,236.8s-14.1-7-26.8,22.81-12.64,106.75-12.64,106.75l-3.14,30.95h0l-70.75-23.72-14,60.13s75.83,27.33,102,31.69,37.7,2,41.27-7.93,9.71-75.39,9.71-75.39l6-59a91.28,91.28,0,0,0-.55-22.88C639.41,279,630.72,238.15,611.51,236.8Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.25,246.58s-.11.09-.35.23-.59.32-1.06.54a34.74,34.74,0,0,1-4,1.68,31.77,31.77,0,0,1-6.33,1.53,25.07,25.07,0,0,1-8-.18,20.1,20.1,0,0,1-7.35-3.09,17.4,17.4,0,0,1-4.63-4.59,13.9,13.9,0,0,1-1.9-4,8.15,8.15,0,0,1-.27-1.17,1.16,1.16,0,0,1,0-.41,18.74,18.74,0,0,0,2.52,5.33,17.83,17.83,0,0,0,4.59,4.4,20.25,20.25,0,0,0,7.19,3,28.83,28.83,0,0,0,14.09-1.19c1.75-.56,3.13-1.11,4.08-1.51A9.89,9.89,0,0,1,497.25,246.58Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.81,225.62a3.8,3.8,0,0,1-.81.64c-.54.38-1.34.91-2.35,1.53a78,78,0,0,1-8.15,4.37,75.86,75.86,0,0,1-8.63,3.35c-1.12.35-2,.62-2.69.78a4.28,4.28,0,0,1-1,.2,37.4,37.4,0,0,1,3.59-1.33c2.21-.8,5.25-2,8.52-3.48s6.14-3,8.19-4.2A34.81,34.81,0,0,1,539.81,225.62Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499,231.05a3.62,3.62,0,1,1-3.62-3.62A3.62,3.62,0,0,1,499,231.05Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 491.76,
    cy: 266.41,
    r: 3.62,
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.38,
    cy: 430.89,
    r: 3.62,
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.24,312.79s0,.46-.11,1.34-.21,2.22-.38,3.94c-.34,3.47-.85,8.57-1.49,15.14-1.32,13.15-3.22,32.17-5.57,55.66-1.15,11.76-2.47,24.63-4.13,38.42-.85,6.89-1.74,14-2.95,21.33l-.48,2.74-.57,2.76a21.66,21.66,0,0,1-1.78,5.42,13.28,13.28,0,0,1-3.79,4.38l-1.23.82c-.42.24-.87.44-1.31.67l-.67.32-.69.24-1.4.5a42.38,42.38,0,0,1-11.81,1.26,108.07,108.07,0,0,1-12.11-1c-4.07-.49-8.14-1.19-12.25-2S573.33,463,569.2,462c-16.51-4.05-33.45-8.84-50.75-13.87q-18-5.24-35.22-10.54l-.23-.07.06-.23c5-21.58,9.86-42.25,14.39-61.62l.05-.25.25.07L569,397.13l-.25.17c2.72-26.56,4.93-48.09,6.46-63,.78-7.43,1.38-13.21,1.79-17.14l.48-4.47c.11-1,.18-1.51.18-1.51s0,.51-.12,1.52-.24,2.51-.43,4.47c-.38,3.93-1,9.71-1.68,17.16-1.49,14.9-3.64,36.43-6.3,63l0,.24-.22-.07L497.61,376l.3-.17c-4.51,19.37-9.32,40-14.35,61.62l-.17-.3q17.19,5.28,35.21,10.53c17.3,5,34.23,9.82,50.72,13.88,4.12,1,8.22,1.95,12.3,2.79s8.16,1.49,12.21,2a105.11,105.11,0,0,0,12,1A42,42,0,0,0,617.56,466a17.63,17.63,0,0,0,5.15-2.47,12.74,12.74,0,0,0,3.65-4.22,21.14,21.14,0,0,0,1.75-5.3l.57-2.74c.16-.92.32-1.83.47-2.74,1.23-7.29,2.13-14.41,3-21.3,1.68-13.78,3-26.65,4.19-38.4,2.42-23.49,4.38-42.5,5.73-55.65.69-6.56,1.23-11.66,1.6-15.13.18-1.72.33-3,.42-3.93S644.24,312.79,644.24,312.79Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.15,424.35c-.1,0-.45-1.86-1.43-4.77a44.51,44.51,0,0,0-2-5,47.66,47.66,0,0,0-3.3-5.7,47.16,47.16,0,0,0-4.13-5.15,44,44,0,0,0-3.91-3.7c-2.36-2-4-3-3.94-3.06a6.4,6.4,0,0,1,1.18.65c.37.22.82.51,1.31.87s1.09.75,1.68,1.25a39.3,39.3,0,0,1,4,3.66,44.12,44.12,0,0,1,4.21,5.18,45.38,45.38,0,0,1,3.31,5.8,39.32,39.32,0,0,1,2,5.08c.25.74.4,1.42.56,2A15.08,15.08,0,0,1,587,423,6.8,6.8,0,0,1,587.15,424.35Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.81,236.34a2.25,2.25,0,0,1-.49.31c-.39.2-.87.47-1.45.79l-1.06.56c-.37.21-.77.47-1.2.74-.86.54-1.88,1.11-2.9,1.88l-1.63,1.17c-.56.41-1.11.89-1.69,1.36-1.19.92-2.34,2-3.57,3.2a58.81,58.81,0,0,0-7,8.45,59.54,59.54,0,0,0-5.18,9.67c-.6,1.58-1.22,3.07-1.62,4.52-.21.72-.46,1.4-.62,2.08s-.32,1.33-.47,1.95c-.33,1.24-.47,2.39-.65,3.39-.09.5-.18,1-.24,1.4s-.08.82-.12,1.19c-.07.66-.13,1.2-.18,1.64a2.51,2.51,0,0,1-.1.57,2.34,2.34,0,0,1,0-.58q0-.64.09-1.65c0-.37,0-.77.08-1.2s.12-.9.19-1.41a34,34,0,0,1,.58-3.42c.14-.64.29-1.29.44-2s.39-1.38.6-2.11c.39-1.47,1-3,1.58-4.57A53.55,53.55,0,0,1,592.48,246c1.26-1.15,2.42-2.28,3.64-3.19.59-.47,1.15-.95,1.72-1.35l1.67-1.15a33.5,33.5,0,0,1,3-1.83c.44-.26.85-.51,1.23-.71l1.08-.52,1.5-.71A2.43,2.43,0,0,1,606.81,236.34Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,312.42l5.36,43.86s4.44,62.94,26,62.94c22.24,0,45.83-10.06,51.12-17.7s45.89-58,45.89-58l-9.29-96.12S416,259.73,409.42,274.88s-42.14,64.05-42.14,64.05l-6.58-30.54Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.19,346.89a3.76,3.76,0,0,1,.31.57c.22.43.49,1,.83,1.66s.79,1.62,1.2,2.69,1,2.26,1.41,3.64c.23.69.48,1.4.74,2.15s.44,1.54.68,2.36c.5,1.63.87,3.41,1.28,5.28a74,74,0,0,1,.79,24.78c-.3,1.89-.55,3.69-.95,5.34-.18.83-.33,1.64-.53,2.41l-.6,2.19c-.35,1.4-.82,2.63-1.18,3.72a27.45,27.45,0,0,1-1,2.75c-.29.71-.53,1.28-.72,1.72a2.21,2.21,0,0,1-.28.58,4.05,4.05,0,0,1,.19-.62c.16-.45.37-1,.62-1.75s.63-1.68.95-2.78.77-2.32,1.09-3.72l.57-2.19c.19-.76.32-1.57.5-2.39.37-1.65.61-3.45.89-5.33a84.82,84.82,0,0,0,.61-12.34,83.51,83.51,0,0,0-1.39-12.28c-.4-1.86-.75-3.63-1.22-5.26-.23-.81-.42-1.61-.66-2.35s-.48-1.47-.7-2.15c-.41-1.38-.93-2.58-1.33-3.65s-.78-2-1.11-2.71-.55-1.27-.74-1.71A2.67,2.67,0,0,1,370.19,346.89Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.12,335c-.14,0-2.41-10.63-5.07-23.79s-4.7-23.87-4.56-23.89,2.41,10.62,5.07,23.78S437.26,335,437.12,335Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.6,322.36a3.62,3.62,0,1,1-3.62-3.62A3.62,3.62,0,0,1,326.6,322.36Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.77,309.68l-6.19-33.54-36.1-5.73c.58,0-.11,41.56-.11,41.56Z",
    style: {
      fill: "#ffd1bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.17,195.54l-11.53,13-2.56,1.6a6.43,6.43,0,0,0-2.91,4.35l-.56,3.28s-2.49-.36-2.84,2.84,0,6.29,2.13,8.51c2.64,2.83,9.18,8.54,9.18,8.54s9.47,13.06,9.6,14.63c.64,7.74.45,37.56.45,37.56l40.93-2-14.61-55.43s1.57-1,1.28-5.57a9.32,9.32,0,0,0,.29-6.27s.85-5.71-.57-8.13a7.63,7.63,0,0,0,2.85-4.14c.57-2.57-1.43-5-5.28-7.56s-10.13-7.13-12.41-7.7c-1.36-.34-5.11-.23-7.91-.08A8,8,0,0,0,315.17,195.54Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.8,235.68l5.11,13.87a5.72,5.72,0,0,0,3.4,1c2.19,0,6.45-.74,8.37-2.67a8.07,8.07,0,0,0,1.88-4.7l-5.87-15.49-6.57-1.22-4.62,3.65Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.52,247l34.57,85.34,4.1-1.45-30.06-86.22S335.28,241.79,331.52,247Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.79,235.83a19.09,19.09,0,0,1-2.38-.48,11.76,11.76,0,0,0-5.68.23,10.32,10.32,0,0,0-2.79,1.43,11.43,11.43,0,0,0-1.86,1.78c-1,1.14-1.35,2-1.42,2a5.33,5.33,0,0,1,1.13-2.18,10.68,10.68,0,0,1,1.86-1.93,9.86,9.86,0,0,1,2.92-1.54,10.85,10.85,0,0,1,5.92-.1,11,11,0,0,1,1.7.55C339.59,235.69,339.8,235.79,339.79,235.83Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.87,244a23.65,23.65,0,0,0-2.34-1A8.7,8.7,0,0,0,330,247a23.08,23.08,0,0,0-1,2.34,1.78,1.78,0,0,1,.06-.7,7.66,7.66,0,0,1,.65-1.82,8.63,8.63,0,0,1,11-4.19,7.36,7.36,0,0,1,1.69.92C342.72,243.8,342.89,244,342.87,244Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,230a14.64,14.64,0,0,0-1.24-5.39,14.37,14.37,0,0,0-3.57-4.77,16.47,16.47,0,0,0-6.46-3.39,21.14,21.14,0,0,0-7.31-.63,28.83,28.83,0,0,0-5.93,1.16c-1.65.51-2.95,1-3.84,1.39a9.47,9.47,0,0,1-1.41.55,7.73,7.73,0,0,1,1.32-.73,32.63,32.63,0,0,1,3.82-1.56,27.29,27.29,0,0,1,6-1.29,21,21,0,0,1,7.49.61,16.49,16.49,0,0,1,6.63,3.53,14.3,14.3,0,0,1,3.6,5,12.24,12.24,0,0,1,1,4,8,8,0,0,1,0,1.13A1.08,1.08,0,0,1,343,230Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.89,224.64a4.26,4.26,0,0,1-.89,1.72,10.27,10.27,0,0,1-8.17,4.08,4.44,4.44,0,0,1-1.91-.32c0-.09.74,0,1.9-.05a11.34,11.34,0,0,0,7.89-3.94C330.46,225.24,330.82,224.6,330.89,224.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,231.36s-.33.37-1.07.57a4,4,0,0,1-4.81-2.62c-.24-.72-.17-1.2-.11-1.2s.15.44.45,1.07a4.14,4.14,0,0,0,4.4,2.38C342.53,231.47,343,231.28,343,231.36Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.37,219.52a9.65,9.65,0,0,1-1-1.11c-.61-.73-1.51-1.78-2.67-3a63,63,0,0,0-10-8.7,4.11,4.11,0,0,0-3.36-.91,27.77,27.77,0,0,0-3.25,1.28l-5.52,2.34-3.74,1.54a8.6,8.6,0,0,1-1.41.5,7.65,7.65,0,0,1,1.32-.69c1-.44,2.2-1,3.68-1.69l5.48-2.44,1.59-.7a9.93,9.93,0,0,1,1.74-.64,3.61,3.61,0,0,1,2,.07,6.8,6.8,0,0,1,1.78.91,56.55,56.55,0,0,1,10,8.88c1.13,1.29,2,2.37,2.56,3.14A7.5,7.5,0,0,1,343.37,219.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.45,212.37a10.11,10.11,0,0,1-1.24-1L339,208.68a123.75,123.75,0,0,0-11.16-8.46,11.4,11.4,0,0,0-3.58-1.52,6.89,6.89,0,0,0-3.56.22,21.83,21.83,0,0,0-5.43,3,30,30,0,0,1-3.62,2.27,11,11,0,0,1-1.06.46c-.26.09-.39.13-.4.11s.5-.26,1.37-.75a39.35,39.35,0,0,0,3.5-2.39,20.39,20.39,0,0,1,5.5-3.19,7.13,7.13,0,0,1,3.8-.27,11.72,11.72,0,0,1,3.75,1.58,101.05,101.05,0,0,1,11.13,8.62c1.35,1.18,2.42,2.16,3.16,2.85A8.77,8.77,0,0,1,343.45,212.37Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,235.29a5.7,5.7,0,0,1-5.62,3,25.86,25.86,0,0,0,3-1.1A26.43,26.43,0,0,0,323,235.29Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.68,247.35a6.28,6.28,0,0,1-2.13-.24,22,22,0,0,1-4.88-1.68,21.29,21.29,0,0,1-4.37-2.76,6.37,6.37,0,0,1-1.52-1.5,48.12,48.12,0,0,0,6.11,3.79A49.35,49.35,0,0,0,323.68,247.35Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.47,220.31c0,.08-.64-.18-1.67-.26a6.47,6.47,0,0,0-3.8.89,6.34,6.34,0,0,0-2.49,3c-.39,1-.43,1.61-.52,1.61a3,3,0,0,1,.17-1.74,6,6,0,0,1,6.69-4.13A2.92,2.92,0,0,1,306.47,220.31Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.77,339.08l27.84,63.36A7.21,7.21,0,0,0,404,406h0a7.22,7.22,0,0,0,3.74-9.66l-26.88-63.08Z",
    style: {
      fill: "#F0F5FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.77,339.08,367,339l.69-.3,2.72-1.16,10.36-4.37.13-.06.06.13,12.19,28.39c2.44,5.7,5.05,11.82,7.8,18.24l4.2,9.86,2.17,5.08a24.82,24.82,0,0,1,1,2.63,7.27,7.27,0,0,1,.2,2.9,7.49,7.49,0,0,1-1.95,4.17,8,8,0,0,1-1.81,1.42,8.85,8.85,0,0,1-2.15.8,7.52,7.52,0,0,1-7.81-3.34,15.87,15.87,0,0,1-.95-1.95c-.28-.65-.57-1.3-.85-1.94-.57-1.29-1.12-2.57-1.68-3.83-1.1-2.53-2.19-5-3.24-7.41-4.21-9.64-8-18.32-11.18-25.63s-5.71-13.14-7.48-17.23c-.87-2-1.54-3.58-2-4.68l-.51-1.2a2.43,2.43,0,0,1-.16-.41s.08.15.21.43l.56,1.22c.49,1.1,1.19,2.68,2.1,4.7l7.66,17.21,11.27,25.47,3.25,7.36c.55,1.26,1.11,2.52,1.68,3.8l.84,1.93a15.75,15.75,0,0,0,.92,1.89,7,7,0,0,0,7.27,3.1,7.55,7.55,0,0,0,2-.75,7.2,7.2,0,0,0,1.69-1.32,6.94,6.94,0,0,0,1.63-6.57,24.79,24.79,0,0,0-1-2.56c-.72-1.71-1.44-3.41-2.16-5.08l-4.2-9.87-7.75-18.26-12-28.45.19.08-10.34,4.18-2.78,1.12L367,339Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.48,371l13,30.29a6.11,6.11,0,0,0,7.91,3h0a6.1,6.1,0,0,0,3.16-8.17l-12.93-29.74Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.71,
    y: 352.06,
    width: 8.03,
    height: 35.79,
    transform: "translate(-113.93 182.03) rotate(-23.08)",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.13,382.56a1.83,1.83,0,0,1-2.28-2.48l.61.28a1.06,1.06,0,0,0,0,.92,1.06,1.06,0,0,0,2-.83,1,1,0,0,0-.69-.62l.22-.63a1.82,1.82,0,0,1,.21,3.36Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.8,379.42a1.82,1.82,0,1,1,.86-2.34A1.72,1.72,0,0,1,392.8,379.42Zm-1.12-2.63a1,1,0,1,0,1.38.54A1,1,0,0,0,391.68,376.79Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.84,373l-.6.95,0,0,.26.62.85-.36.3.7-3.05,1.31-.57-1.33a1.24,1.24,0,0,1,.55-1.8,1.1,1.1,0,0,1,1.23.22l.69-1.1Zm-2.19,1.72.24.57,1.07-.45-.25-.58c-.18-.43-.48-.56-.81-.42S389.46,374.24,389.65,374.67Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,370.05l3.62,0,.29.7-2.49,2.62-.33-.76,1.79-1.86-2.58,0Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.89,369.8l-.3-.71,3.05-1.3.3.71Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.28,368.37l-.59-1.39a1.67,1.67,0,1,1,3.05-1.31l.59,1.39Zm1.9-2.41a1,1,0,1,0-1.9.8l.28.65,1.89-.81Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.35,364.22l-.53-1.24.54-.23.53,1.23Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.63,362.16l3.06-1.3.3.71-2.49,1.06.26.61-.56.24Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.83,358.57a1.61,1.61,0,0,1,2.31.85,1.72,1.72,0,0,1,.15.94l-.63,0a1.09,1.09,0,0,0-.09-.64.89.89,0,0,0-1.26-.48,1.12,1.12,0,0,1,.6.64,1.06,1.06,0,0,1-.5,1.46,1.14,1.14,0,0,1-1.51-.72A1.42,1.42,0,0,1,383.83,358.57Zm-.2,1a.51.51,0,0,0-.22.73.5.5,0,0,0,.67.32.51.51,0,0,0,.24-.72A.53.53,0,0,0,383.63,359.58Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.38 362.74 495.98 383.16 485.28 427.88 453.88 398.94 463.38 362.74",
    style: {
      fill: "#ffd1bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,341.57s-2.37-4,.08-6.8c2.29-2.6,14.57-13.06,19.41-17.15A6.62,6.62,0,0,1,388,316l22.85.71s11.18-1.27,12.25,0,7.64,9,7.64,9l17.59,26.36,28.91,17.95S481.61,395,458.71,405L442.2,392.71a22.7,22.7,0,0,1-12.83-4c-5.89-4.28-24.46-34.46-24.46-34.46s-17,.31-20.27.7-8.25-.62-8.44-3.11c0,0-3.37,2.07-5.51,1.87a4,4,0,0,1-3.92-3.17,4.83,4.83,0,0,1-3.57-3.87C362.75,342.94,364,341.57,364,341.57Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.35,325.86a12,12,0,0,1-1.09,2.74,33.25,33.25,0,0,1-8.82,11.11,12,12,0,0,1-2.43,1.68,27,27,0,0,1,2.19-2,43.54,43.54,0,0,0,4.84-5.12,42.56,42.56,0,0,0,3.89-5.88A26.1,26.1,0,0,1,429.35,325.86Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.74,330.66a3.86,3.86,0,0,1-.09,1c-.09.66-.27,1.61-.53,2.78a56.59,56.59,0,0,1-7.05,17.24c-.64,1-1.18,1.82-1.58,2.36a3.87,3.87,0,0,1-.66.8c-.06,0,.74-1.28,1.92-3.35a73.27,73.27,0,0,0,4.08-8.33,71.87,71.87,0,0,0,2.93-8.81C431.37,332.09,431.66,330.65,431.74,330.66Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.06,336.2a3.35,3.35,0,0,1,0,1c0,.66-.18,1.6-.39,2.76a38.16,38.16,0,0,1-2.78,8.73,38.92,38.92,0,0,1-4.77,7.83,26,26,0,0,1-1.82,2.1,4.68,4.68,0,0,1-.75.7c-.07-.06.9-1.14,2.27-3a43.79,43.79,0,0,0,7.49-16.42C437.79,337.63,438,336.19,438.06,336.2Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.08,369.93a4.11,4.11,0,0,1-.15,1,25.21,25.21,0,0,1-.72,2.69,34.71,34.71,0,0,1-3.94,8.28,35.11,35.11,0,0,1-6,6.95,24,24,0,0,1-2.17,1.75,3.5,3.5,0,0,1-.86.54c-.06-.07,1.1-.95,2.78-2.56a39.26,39.26,0,0,0,9.81-15.08C454.65,371.32,455,369.91,455.08,369.93Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.56,375.72a13.66,13.66,0,0,1-1.08,2.76,53.08,53.08,0,0,1-3.4,6.29,54.6,54.6,0,0,1-4.17,5.8,13.34,13.34,0,0,1-2,2.16,21.81,21.81,0,0,1,1.73-2.39c1.09-1.46,2.55-3.5,4-5.85s2.68-4.55,3.51-6.17A20.31,20.31,0,0,1,456.56,375.72Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.11,323.27a12.32,12.32,0,0,1-1.79.15l-4.87.24-7.23.27-2.09.08-1.07,0-.55,0-.33.25c-1.17.89-2.35,1.87-3.57,2.87l-12.42,10.24-3.79,3.08a11.12,11.12,0,0,1-1.43,1.07,12.2,12.2,0,0,1,1.3-1.23l3.68-3.2c3.13-2.68,7.47-6.37,12.33-10.37,1.22-1,2.4-2,3.59-2.87a2.14,2.14,0,0,1,.6-.34l.55,0,1.08,0,2.09-.06,7.24-.16,4.89-.07A11.42,11.42,0,0,1,403.11,323.27Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.76,332.25a7,7,0,0,1-1.27.14l-3.5.22-12,.6.15-.06-4.1,3.41c-4.72,3.91-9,7.42-12.12,9.94l-3.72,3a11,11,0,0,1-1.4,1,10.84,10.84,0,0,1,1.28-1.19l3.6-3.09c3.06-2.6,7.31-6.15,12-10.06l4.12-3.4.07-.05h.08l12-.41,3.52-.07A7,7,0,0,1,404.76,332.25Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.75,322.36a9.4,9.4,0,0,1-1.41,1.9c-.94,1.12-2.3,2.62-3.89,4.18s-3.12,2.89-4.26,3.81a9.25,9.25,0,0,1-1.93,1.37A12.6,12.6,0,0,1,405,332c1.07-1,2.55-2.35,4.13-3.9s3-3,4-4.05A12.36,12.36,0,0,1,414.75,322.36Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.3,346.2s-.46-.46-1.37-1.19a14.19,14.19,0,0,0-4.33-2.28,20.88,20.88,0,0,0-7.2-.93,44.3,44.3,0,0,0-8.84,1.45c-3.1.76-6.07,1.52-8.83,1.93a32.62,32.62,0,0,0-3.84.76,8.62,8.62,0,0,0-3,1.47,5.56,5.56,0,0,0-2.12,4.17,4.92,4.92,0,0,0,.43,1.73s-.11-.12-.27-.39a3.6,3.6,0,0,1-.36-1.33,5.64,5.64,0,0,1,2.09-4.46c1.67-1.45,4.26-2,7-2.42s5.67-1.21,8.79-2a43.21,43.21,0,0,1,8.95-1.42,20.7,20.7,0,0,1,7.33,1.06,13.36,13.36,0,0,1,4.34,2.48,9.44,9.44,0,0,1,1,1C416.22,346.06,416.32,346.19,416.3,346.2Z",
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "speech-bubble",
    "data-motion": "float",
    "data-delay": 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.08,169.23l-15.23-26.84a71.88,71.88,0,1,0-17.22,19.16l0,0Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.08,169.23l-32.5-7.52a.13.13,0,0,1-.1-.16.08.08,0,0,1,0-.05l0,0,.18.18A73.64,73.64,0,0,1,326,170.52a71.76,71.76,0,0,1-19.66,5.6,72.64,72.64,0,0,1-11.35.61,69.47,69.47,0,0,1-12-1.28A72.05,72.05,0,0,1,226.09,119a73.16,73.16,0,0,1,.78-31.88,71.76,71.76,0,0,1,15.4-29.46,74.06,74.06,0,0,1,6-6.22A73,73,0,0,1,255,46.07,70.43,70.43,0,0,1,269.88,38a72.82,72.82,0,0,1,16-4.36A74.28,74.28,0,0,1,302,33a71.42,71.42,0,0,1,29.47,8.75,71.5,71.5,0,0,1,36.58,53.73c.28,2,.39,3.88.53,5.79s.11,3.78,0,5.62A71.19,71.19,0,0,1,365.13,127,72.92,72.92,0,0,1,358,142.46v-.13l15.12,26.9c-.45-.78-5.45-9.5-15.34-26.78a.13.13,0,0,1,0-.12,72.86,72.86,0,0,0,7.1-15.41,71.3,71.3,0,0,0,3.42-20c.07-1.83,0-3.7-.06-5.6s-.24-3.82-.53-5.75a71.7,71.7,0,0,0-36.43-53.37A71,71,0,0,0,302,33.49a73.81,73.81,0,0,0-16,.6,72.25,72.25,0,0,0-15.86,4.34,69.64,69.64,0,0,0-14.74,8.06,73.44,73.44,0,0,0-6.66,5.34,72.15,72.15,0,0,0-21.3,35.41,72.63,72.63,0,0,0-.79,31.66A71.62,71.62,0,0,0,283,175.05,69.59,69.59,0,0,0,295,176.34a71,71,0,0,0,30.87-6.1,73.27,73.27,0,0,0,14.73-8.8.13.13,0,0,1,.18,0,.12.12,0,0,1,0,.16l0,0-.07-.21Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.57,
    cy: 88.13,
    r: 8.97,
    transform: "translate(-2.5 166.31) rotate(-28.22)",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.81,94.85c0-.47.91-.74,2-1.33l.42-.24.43-.27a8.67,8.67,0,0,0,.87-.66,7.31,7.31,0,0,0,1.55-1.79,7.62,7.62,0,0,0,.84-2.22,10.85,10.85,0,0,0,.16-1.08c0-.17,0-.34,0-.5s0-.33,0-.48c0-1.23-.17-2.13.22-2.38a.4.4,0,0,1,.36,0,1.61,1.61,0,0,1,.5.28,4.19,4.19,0,0,1,1.14,1.6,5,5,0,0,1,.23.62,7,7,0,0,1,.18.69,7.32,7.32,0,0,1,.13,1.59,7.56,7.56,0,0,1-1,3.57,7.74,7.74,0,0,1-1.22,1.53,7.41,7.41,0,0,1-1.42,1.08,8.33,8.33,0,0,1-1.46.64,6.46,6.46,0,0,1-.7.17,5.32,5.32,0,0,1-.65.09,4.19,4.19,0,0,1-1.95-.23,1.47,1.47,0,0,1-.48-.31A.42.42,0,0,1,328.81,94.85Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M338.48,78.82c-.11.15-.59,0-1.08-.33a2.61,2.61,0,0,1-.42-.36c-.23-.23-.34-.44-.26-.54s.59,0,1.08.32S338.59,78.66,338.48,78.82Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.25,80.59A16.07,16.07,0,0,0,337,78.15l.87.62s-1.62,2.44-1.7,3.39A17.22,17.22,0,0,0,334.25,80.59Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M337,78.17a3.65,3.65,0,0,0,.88.6l-.35.54a3.66,3.66,0,0,1-.68-1Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M332,76.86c0,.19-.5.31-1.1.26a2.17,2.17,0,0,1-.54-.09c-.31-.08-.51-.21-.5-.34s.51-.31,1.1-.26S332,76.67,332,76.86Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.76,79.36a9,9,0,0,0,.6-2.34l1.06.1a5.72,5.72,0,0,0,.24,2.46A11.75,11.75,0,0,0,329.76,79.36Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M330.36,77a2.33,2.33,0,0,0,1.06.08c0,.19,0,.41,0,.64a3.57,3.57,0,0,1-1.05-.48Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M325.94,76c.09.17-.29.52-.82.77a3.74,3.74,0,0,1-.52.19c-.31.07-.55.06-.61-.06s.29-.51.83-.77S325.86,75.78,325.94,76Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.35,80.51a15.82,15.82,0,0,0-.72-3.63l1-.44s1.3,2.64,2.08,3.19A15.79,15.79,0,0,0,325.35,80.51Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M324.64,76.9a3.23,3.23,0,0,0,1-.46c.09.18.19.38.3.58a3.41,3.41,0,0,1-1.17.1Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M321,80.46c.16.11,0,.59-.33,1.08a2.61,2.61,0,0,1-.35.43c-.23.22-.44.33-.55.26s0-.6.33-1.08S320.83,80.35,321,80.46Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.05,83.61a9.14,9.14,0,0,0-1.73-1.69l.62-.87a5.81,5.81,0,0,0,2.25,1A12.22,12.22,0,0,0,322.05,83.61Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M320.34,81.93a2.3,2.3,0,0,0,.6-.88,6.32,6.32,0,0,0,.54.36,3.4,3.4,0,0,1-1,.66Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M316.82,87.58c.19,0,.42.42.51,1a3.74,3.74,0,0,1,0,.55c0,.32-.09.55-.22.57s-.42-.43-.51-1S316.63,87.61,316.82,87.58Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,89.42a15.72,15.72,0,0,0-3.69-.32L317.2,88a13.2,13.2,0,0,0,3.63-1.11A17,17,0,0,0,321,89.42Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M317.37,89.09a3.48,3.48,0,0,0-.17-1l.63-.12a3.5,3.5,0,0,1-.23,1.15Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M319.69,94c.16-.11.55.21.88.71a2.6,2.6,0,0,1,.26.49c.12.29.14.53,0,.6s-.56-.21-.89-.71S319.53,94.06,319.69,94Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,94.16a8.71,8.71,0,0,0-2.22,1l-.57-.9a5.85,5.85,0,0,0,1.8-1.69A12.71,12.71,0,0,0,323,94.16Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M320.81,95.1a2.36,2.36,0,0,0-.59-.88l.53-.36A3.25,3.25,0,0,1,321,95Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M324.87,100c.06-.19.56-.21,1.13,0a2.26,2.26,0,0,1,.52.2c.29.14.46.31.42.43s-.56.2-1.13,0S324.82,100.15,324.87,100Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.3,96.92a15.81,15.81,0,0,0-1.83,3.21l-1-.31s.75-2.83.51-3.76A16.5,16.5,0,0,0,328.3,96.92Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M326.48,100.11a3.61,3.61,0,0,0-1-.29c.05-.19.1-.41.15-.63a3.55,3.55,0,0,1,1,.7Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M326.87,85.1c-.64.28-1.31.15-1.49-.28s.18-1,.82-1.27,1.31-.15,1.49.28S327.51,84.83,326.87,85.1Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M327.4,84.53c-.64.27-1.31.15-1.49-.28s.18-1,.82-1.27,1.31-.15,1.49.28S328,84.26,327.4,84.53Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.4,84.53c-.64.27-1.31.15-1.49-.28s.18-1,.82-1.27,1.31-.15,1.49.28S328,84.26,327.4,84.53Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M333.38,81.94c.54.44.74,1.08.44,1.45s-1,.3-1.51-.13-.74-1.09-.44-1.45S332.83,81.51,333.38,81.94Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M333.84,81.34c.54.43.74,1.08.44,1.45s-1,.3-1.51-.13-.74-1.09-.44-1.45S333.29,80.9,333.84,81.34Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.84,81.34c.54.43.74,1.08.44,1.45s-1,.3-1.51-.13-.74-1.09-.44-1.45S333.29,80.9,333.84,81.34Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M324.38,88.88a.83.83,0,0,1-1.09-.44.83.83,0,1,1,1.09.44Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M324.79,88.7a.83.83,0,1,1,.43-1.08A.82.82,0,0,1,324.79,88.7Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.79,88.7a.83.83,0,1,1,.43-1.08A.82.82,0,0,1,324.79,88.7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M333.31,91a1,1,0,0,1-.63-1.3,1,1,0,0,1,1.92.68A1,1,0,0,1,333.31,91Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M333.82,91.21a1,1,0,1,1,1.3-.62A1,1,0,0,1,333.82,91.21Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.82,91.21a1,1,0,1,1,1.3-.62A1,1,0,0,1,333.82,91.21Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M325.29,93.07a.6.6,0,1,1,.32-.79A.6.6,0,0,1,325.29,93.07Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M325.59,93a.61.61,0,1,1,.32-.8A.61.61,0,0,1,325.59,93Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.59,93a.61.61,0,1,1,.32-.8A.61.61,0,0,1,325.59,93Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M333.44,100.42c-.08-.18.28-.52.81-.76a2.55,2.55,0,0,1,.52-.19c.3-.08.54-.06.59,0s-.28.51-.82.76S333.52,100.59,333.44,100.42Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,95.92a15.69,15.69,0,0,0,.7,3.59l-1,.43a13.08,13.08,0,0,0-2-3.15A16.66,16.66,0,0,0,334,95.92Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M334.72,99.48a3.23,3.23,0,0,0-1,.46c-.08-.18-.19-.38-.29-.57a3.34,3.34,0,0,1,1.16-.1Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M338.35,95.82c-.16-.11,0-.59.32-1.07a2.16,2.16,0,0,1,.35-.42c.23-.22.44-.33.54-.26s0,.59-.32,1.07S338.51,95.93,338.35,95.82Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.31,92.7a8.6,8.6,0,0,0,1.7,1.68l-.61.85a5.83,5.83,0,0,0-2.22-1A12.12,12.12,0,0,0,337.31,92.7Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M339,94.36a2.34,2.34,0,0,0-.59.87l-.53-.35a3.6,3.6,0,0,1,.93-.66Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M342.11,91.14c-.19,0-.3-.51-.25-1.09a3.73,3.73,0,0,1,.1-.54c.09-.3.22-.5.35-.49s.29.51.24,1.09S342.3,91.15,342.11,91.14Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.52,88.36a15.49,15.49,0,0,0,3.45,1.2l-.11,1a13,13,0,0,0-3.75.2A16.48,16.48,0,0,0,338.52,88.36Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M342,89.55a3.42,3.42,0,0,0-.09,1l-.64,0a3.4,3.4,0,0,1,.5-1Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M340.73,84.67c-.17.08-.51-.29-.76-.82a2.48,2.48,0,0,1-.19-.51c-.08-.31-.06-.54.05-.6s.51.29.76.82S340.9,84.59,340.73,84.67Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.51,84a8.66,8.66,0,0,0,2.31-.63l.43,1a5.8,5.8,0,0,0-2,1.4A12.45,12.45,0,0,0,337.51,84Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M339.79,83.38a2.33,2.33,0,0,0,.46,1l-.57.28a3.47,3.47,0,0,1-.1-1.14Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M328.13,94.27c-.69-.06-1.22-.48-1.18-1s.63-.8,1.32-.74,1.22.48,1.18,1S328.82,94.32,328.13,94.27Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M328.59,94.47c-.69-.06-1.22-.48-1.19-1s.63-.8,1.33-.74,1.22.48,1.18.94S329.28,94.52,328.59,94.47Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.59,94.47c-.69-.06-1.22-.48-1.19-1s.63-.8,1.33-.74,1.22.48,1.18.94S329.28,94.52,328.59,94.47Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M330.31,89.18a1.26,1.26,0,1,1,.66-1.65A1.26,1.26,0,0,1,330.31,89.18Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M331,88.89a1.26,1.26,0,1,1,.66-1.65A1.26,1.26,0,0,1,331,88.89Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331,88.89a1.26,1.26,0,1,1,.66-1.65A1.26,1.26,0,0,1,331,88.89Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M325.27,94.88c-.06.09-.29.06-.64-.11a5.13,5.13,0,0,1-1.32-1,7.33,7.33,0,0,1-.75-.86,9,9,0,0,1-.7-1.12,8.5,8.5,0,0,1-.88-2.9,8.46,8.46,0,0,1,.65-4.28,7.74,7.74,0,0,1,.54-1,5.55,5.55,0,0,1,1.06-1.25c.31-.24.53-.32.61-.25s-.23.86-.65,2c-.11.29-.2.61-.3,1a10.57,10.57,0,0,0-.24,1.1,10.14,10.14,0,0,0-.07,2.54,9.64,9.64,0,0,0,.64,2.46,10.76,10.76,0,0,0,.47,1c.17.31.34.6.5.86C324.86,94.1,325.41,94.69,325.27,94.88Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M326.7,80.77a.78.78,0,0,1-.33,1.06.81.81,0,0,1-.71-1.45A.78.78,0,0,1,326.7,80.77Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M328.61,123.13a4.09,4.09,0,1,1,2.14-5.37A4.09,4.09,0,0,1,328.61,123.13Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.65,122.44c0-.21.42-.34.91-.61l.19-.11.19-.12a3.47,3.47,0,0,0,.4-.3,3.33,3.33,0,0,0,.71-.82,3.55,3.55,0,0,0,.38-1,4.13,4.13,0,0,0,.07-.49c0-.08,0-.15,0-.23v-.22c0-.56-.08-1,.1-1.08a.18.18,0,0,1,.16,0,.72.72,0,0,1,.24.13,1.85,1.85,0,0,1,.51.73c0,.09.07.18.11.28s.05.21.08.32a3.28,3.28,0,0,1,.06.72,3.38,3.38,0,0,1-.12.81,3.61,3.61,0,0,1-.35.82,3.79,3.79,0,0,1-.55.69,3.32,3.32,0,0,1-.66.49,3,3,0,0,1-.66.3l-.32.08-.29,0a1.89,1.89,0,0,1-.89-.11.56.56,0,0,1-.22-.14A.21.21,0,0,1,326.65,122.44Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M331.06,115.13c-.05.07-.27,0-.5-.15a1,1,0,0,1-.19-.16c-.1-.1-.15-.2-.12-.25s.27,0,.5.15S331.11,115.06,331.06,115.13Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.13,115.94a7,7,0,0,0,1.26-1.11l.4.28a6,6,0,0,0-.78,1.55A7.55,7.55,0,0,0,329.13,115.94Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M330.39,114.84a1.53,1.53,0,0,0,.4.27c-.05.08-.11.16-.16.25a1.56,1.56,0,0,1-.31-.44Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M328.08,114.24c0,.09-.23.14-.5.12l-.25,0c-.14,0-.23-.1-.22-.15s.23-.15.5-.13S328.09,114.15,328.08,114.24Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.08,115.38a4.2,4.2,0,0,0,.28-1.07l.48,0a2.62,2.62,0,0,0,.11,1.12A5.26,5.26,0,0,0,327.08,115.38Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M327.35,114.33a1.14,1.14,0,0,0,.49,0,2.64,2.64,0,0,0,0,.29,1.5,1.5,0,0,1-.48-.22Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M325.34,113.83c0,.08-.13.24-.37.35l-.24.09c-.14,0-.25,0-.27,0s.13-.23.37-.35S325.31,113.75,325.34,113.83Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.07,115.9a7.48,7.48,0,0,0-.32-1.65l.44-.2a6,6,0,0,0,.95,1.45A8.47,8.47,0,0,0,325.07,115.9Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M324.75,114.26a1.62,1.62,0,0,0,.44-.21l.14.27a1.81,1.81,0,0,1-.54,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M323.09,115.88c.07.05,0,.27-.15.5a1.6,1.6,0,0,1-.16.19c-.11.1-.2.15-.25.12s0-.27.15-.5S323,115.83,323.09,115.88Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.57,117.32a3.81,3.81,0,0,0-.79-.77l.28-.4a2.58,2.58,0,0,0,1,.47A4.88,4.88,0,0,0,323.57,117.32Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M322.79,116.55a1,1,0,0,0,.27-.4l.25.16a1.69,1.69,0,0,1-.43.31Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M321.19,119.13c.08,0,.19.19.23.46a2.29,2.29,0,0,1,0,.25c0,.14,0,.25-.1.26s-.19-.2-.23-.46S321.1,119.14,321.19,119.13Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.1,120a7,7,0,0,0-1.67-.14l-.07-.48a6.15,6.15,0,0,0,1.65-.51A8.82,8.82,0,0,0,323.1,120Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M321.44,119.82a1.51,1.51,0,0,0-.08-.48l.29-.06a1.62,1.62,0,0,1-.11.53Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M322.49,122c.08,0,.26.1.41.32a.9.9,0,0,1,.11.22c.06.14.07.25,0,.28s-.25-.1-.4-.32S322.42,122.08,322.49,122Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,122.13a3.78,3.78,0,0,0-1,.43l-.26-.41a2.68,2.68,0,0,0,.82-.77A5,5,0,0,0,324,122.13Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M323,122.55a1.12,1.12,0,0,0-.27-.4L323,122a1.5,1.5,0,0,1,.12.51Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M324.86,124.77c0-.08.25-.09.51,0l.24.09c.13.07.21.15.19.2s-.26.09-.52,0S324.83,124.86,324.86,124.77Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.42,123.38a7.49,7.49,0,0,0-.84,1.47l-.46-.14a5.94,5.94,0,0,0,.23-1.72A7.46,7.46,0,0,0,326.42,123.38Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M325.59,124.83a1.68,1.68,0,0,0-.47-.12c0-.09.05-.19.07-.29a1.71,1.71,0,0,1,.43.31Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M325.77,118c-.29.12-.6.06-.68-.13s.08-.46.37-.58.6-.07.68.13S326.06,117.87,325.77,118Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M326,117.74c-.29.12-.6.06-.68-.13s.08-.46.37-.58.6-.07.68.13S326.3,117.61,326,117.74Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326,117.74c-.29.12-.6.06-.68-.13s.08-.46.37-.58.6-.07.68.13S326.3,117.61,326,117.74Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M328.73,116.56c.25.2.34.49.21.66a.52.52,0,0,1-.69-.06c-.25-.2-.34-.5-.21-.66S328.48,116.36,328.73,116.56Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M328.94,116.28c.25.2.34.5.2.66s-.44.14-.68-.06-.34-.49-.21-.66S328.69,116.08,328.94,116.28Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.94,116.28c.25.2.34.5.2.66s-.44.14-.68-.06-.34-.49-.21-.66S328.69,116.08,328.94,116.28Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M324.63,119.72a.37.37,0,0,1-.49-.2.36.36,0,0,1,.19-.49.37.37,0,0,1,.5.19A.39.39,0,0,1,324.63,119.72Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M324.82,119.64a.39.39,0,0,1-.5-.2.37.37,0,0,1,.2-.49.36.36,0,0,1,.49.19A.37.37,0,0,1,324.82,119.64Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.82,119.64a.39.39,0,0,1-.5-.2.37.37,0,0,1,.2-.49.36.36,0,0,1,.49.19A.37.37,0,0,1,324.82,119.64Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M328.7,120.7a.47.47,0,0,1,.31-.88.47.47,0,0,1-.31.88Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M328.93,120.78a.46.46,0,1,1,.31-.87.46.46,0,1,1-.31.87Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.93,120.78a.46.46,0,1,1,.31-.87.46.46,0,1,1-.31.87Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M325.05,121.63a.28.28,0,0,1-.37-.15.28.28,0,0,1,.51-.21A.27.27,0,0,1,325.05,121.63Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M325.18,121.57a.27.27,0,0,1-.36-.14.28.28,0,0,1,.14-.37.29.29,0,0,1,.37.15A.28.28,0,0,1,325.18,121.57Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.18,121.57a.27.27,0,0,1-.36-.14.28.28,0,0,1,.14-.37.29.29,0,0,1,.37.15A.28.28,0,0,1,325.18,121.57Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M328.76,125c0-.08.13-.24.37-.35l.23-.09c.15,0,.25,0,.28,0s-.13.23-.38.34S328.8,125.05,328.76,125Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,122.93a6.81,6.81,0,0,0,.32,1.63l-.44.2a6,6,0,0,0-.93-1.44A8,8,0,0,0,329,122.93Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M329.34,124.55a1.62,1.62,0,0,0-.43.21l-.13-.26a1.65,1.65,0,0,1,.53,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M331,122.88c-.07,0,0-.27.14-.49l.16-.19c.11-.1.2-.15.25-.12s0,.27-.15.49S331.07,122.93,331,122.88Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.52,121.46a4,4,0,0,0,.78.76l-.28.39a2.55,2.55,0,0,0-1-.46A5.48,5.48,0,0,0,330.52,121.46Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M331.29,122.22a1,1,0,0,0-.27.39l-.24-.16a1.83,1.83,0,0,1,.42-.3Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M332.71,120.75c-.09,0-.14-.23-.11-.5a1.5,1.5,0,0,1,0-.24c0-.14.1-.23.16-.23s.14.23.11.5S332.8,120.75,332.71,120.75Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.08,119.48a7,7,0,0,0,1.57.55l0,.47a6,6,0,0,0-1.71.09A8,8,0,0,0,331.08,119.48Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M332.64,120a1.44,1.44,0,0,0,0,.47h-.29a1.78,1.78,0,0,1,.22-.48Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M332.08,117.8c-.08,0-.23-.13-.35-.37a2.25,2.25,0,0,1-.08-.24c0-.14,0-.24,0-.27s.24.13.35.37S332.16,117.76,332.08,117.8Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.62,117.5a4,4,0,0,0,1.05-.29l.19.44a2.56,2.56,0,0,0-.91.64A5.45,5.45,0,0,0,330.62,117.5Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M331.65,117.21a1.15,1.15,0,0,0,.21.44l-.26.12a1.66,1.66,0,0,1,0-.52Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M326.34,122.17c-.31,0-.56-.22-.54-.43s.29-.36.6-.34.56.22.54.44S326.66,122.2,326.34,122.17Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M326.55,122.26c-.32,0-.56-.22-.54-.43s.29-.36.6-.33.56.21.54.43S326.86,122.29,326.55,122.26Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.55,122.26c-.32,0-.56-.22-.54-.43s.29-.36.6-.33.56.21.54.43S326.86,122.29,326.55,122.26Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M327.33,119.85a.57.57,0,0,1-.75-.3.57.57,0,0,1,1.05-.45A.56.56,0,0,1,327.33,119.85Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M327.64,119.72a.57.57,0,0,1-.45-1,.57.57,0,0,1,.75.3A.56.56,0,0,1,327.64,119.72Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.64,119.72a.57.57,0,0,1-.45-1,.57.57,0,0,1,.75.3A.56.56,0,0,1,327.64,119.72Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M325,122.45s-.14,0-.3,0a2.29,2.29,0,0,1-.6-.44,4.75,4.75,0,0,1-.34-.39,3.64,3.64,0,0,1-.31-.51,3.84,3.84,0,0,1-.41-1.33,3.88,3.88,0,0,1,.1-1.38,3.49,3.49,0,0,1,.2-.57,4.6,4.6,0,0,1,.24-.45,2.51,2.51,0,0,1,.49-.57c.14-.11.24-.15.27-.12s-.1.39-.29.92c0,.13-.09.27-.14.43a3.69,3.69,0,0,0-.1.5,4.43,4.43,0,0,0,0,1.16,4.59,4.59,0,0,0,.29,1.12,5.12,5.12,0,0,0,.22.47,3.64,3.64,0,0,0,.23.39C324.85,122.1,325.1,122.37,325,122.45Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M325.69,116a.35.35,0,1,1-.47-.18A.36.36,0,0,1,325.69,116Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M274,131.32a20.78,20.78,0,0,0,7.77,2.38c1.24,1.9,2,8.42,2,8.42l2.44-.18c-.19-2.61,1.08-7.7,1.26-8.42a20.81,20.81,0,0,0,6.07-2.05c2,.93,4.06,4,4.06,4l2-1.39a20.72,20.72,0,0,1-2.4-5.08,21.18,21.18,0,0,0,3.31-3.45c2.22-.17,8.32,2.54,8.32,2.54l1.07-2.2c-2.52-1.24-6.56-5.31-6.59-5.33a20.6,20.6,0,0,0,1.37-6c1.84-1.21,5.59-1.48,5.59-1.48l-.19-2.44a20.14,20.14,0,0,1-5.51-.44,21,21,0,0,0-1.39-5.21c1.09-2.06,6.33-5.94,6.33-5.94l-1.4-2c-2.09,1.42-6.74,2.78-7.78,3.08a20.64,20.64,0,0,0-5.09-4.64,14.71,14.71,0,0,1,1.43-5.13l-2.24-1.05a20.28,20.28,0,0,1-2.84,4.29,20.43,20.43,0,0,0-5.41-1.34c-1.07-2.39-1.69-8-1.69-8l-2.47.18c.17,2.28-.77,6.34-1.15,7.88a20.71,20.71,0,0,0-6.55,2.11,14.73,14.73,0,0,1-3.67-3.79l-2,1.41a19.73,19.73,0,0,1,2.28,4.62,20.86,20.86,0,0,0-5.56,6.84c-2.45.48-8.4-.55-8.4-.55l-.51,2.42a31.66,31.66,0,0,1,7.11,3.22,21.15,21.15,0,0,0-.44,5.54,21.59,21.59,0,0,0,.38,2.81,15,15,0,0,1-4.82,1.9l.54,2.42a20.48,20.48,0,0,1,5.48-.35,20.69,20.69,0,0,0,4.94,7.16c-.74,2.5-4,7.17-4,7.17l2,1.48C269.14,134.7,273.21,131.85,274,131.32Zm30.61-20.42v-.08A.25.25,0,0,0,304.59,110.9Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.89,127.07c.46-1,2.57-.89,5.4-1.33.35,0,.72-.13,1.1-.19s.76-.17,1.16-.25a22.84,22.84,0,0,0,2.42-.74,17.57,17.57,0,0,0,4.8-2.71,17.16,17.16,0,0,0,3.59-4.17,22.5,22.5,0,0,0,1.21-2.24c.16-.37.33-.73.47-1.08s.3-.7.4-1c1-2.69,1.32-4.78,2.37-5a1.05,1.05,0,0,1,.81.22,3.23,3.23,0,0,1,.88,1,9.69,9.69,0,0,1,1.22,4.39,12.9,12.9,0,0,1,0,1.53c0,.54-.09,1.09-.16,1.66a17.05,17.05,0,0,1-2.95,7.24,16.9,16.9,0,0,1-7,5.71,17.35,17.35,0,0,1-4,1.22,17.09,17.09,0,0,1-3.7.26c-.58-.05-1.13-.09-1.66-.17a15.19,15.19,0,0,1-1.5-.32,9.89,9.89,0,0,1-4.07-2.06,3.41,3.41,0,0,1-.82-1.06A1,1,0,0,1,276.89,127.07Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M310.72,99.67c-.37.26-1.31-.44-2.11-1.57A6.81,6.81,0,0,1,308,97c-.31-.68-.38-1.23-.14-1.4s1.31.44,2.11,1.57S311.09,99.41,310.72,99.67Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M308,97.09a8.14,8.14,0,0,0,1.45,2c-.36.27-.78.59-1.19.92a8.3,8.3,0,0,1-.72-2.65Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M298,90.23c-.19.41-1.36.28-2.61-.29a6.48,6.48,0,0,1-1.12-.63c-.61-.43-.95-.87-.83-1.14s1.36-.28,2.61.29S298.18,89.82,298,90.23Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M294.36,89.37a5.44,5.44,0,0,0,2.26,1c-.2.41-.39.88-.58,1.37a7.83,7.83,0,0,1-1.92-1.89Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M285.57,83.5c0,.45-1,.91-2.42,1a6.83,6.83,0,0,1-1.28,0c-.74-.08-1.25-.29-1.28-.59s1-.9,2.42-1S285.53,83.06,285.57,83.5Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M282,84.54a8,8,0,0,0,2.46-.24c.06.45.12,1,.2,1.5a8.06,8.06,0,0,1-2.65-.72Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M271.17,89.42c.26.37-.44,1.31-1.56,2.11a5.69,5.69,0,0,1-1.11.65c-.68.31-1.23.39-1.4.14s.44-1.31,1.56-2.11S270.91,89.06,271.17,89.42Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M268.6,92.14a5.53,5.53,0,0,0,2-1.46c.26.38.56.79.89,1.2a8,8,0,0,1-2.6.71Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M256.43,101.7c.44.08.58,1.25.32,2.61a7.47,7.47,0,0,1-.36,1.23c-.28.69-.63,1.12-.92,1.06-.44-.08-.58-1.25-.32-2.61S256,101.61,256.43,101.7Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M256.43,105.44a7.89,7.89,0,0,0,.45-2.44c.45.08,1,.16,1.49.23a8,8,0,0,1-1.42,2.34Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M257.66,117.89c.43-.11,1,.9,1.36,2.24a6.25,6.25,0,0,1,.18,1.27c0,.75-.11,1.29-.4,1.35s-1-.9-1.36-2.24S257.22,118,257.66,117.89Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M259.2,121.3a5.53,5.53,0,0,0-.6-2.41c.46-.09.94-.22,1.45-.37a8,8,0,0,1-.32,2.67Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M264.23,135.15c.26-.37,1.38,0,2.5.81a6.37,6.37,0,0,1,1,.84c.51.54.76,1,.58,1.28s-1.38,0-2.5-.81S264,135.51,264.23,135.15Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M267.63,136.72a8,8,0,0,0-2-1.43l.84-1.26A8,8,0,0,1,268,136.3Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M280.36,104.23c-1.61.09-3-.71-3-1.8s1.19-2,2.8-2.13,3,.71,3,1.8S282,104.14,280.36,104.23Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M282,103.4c-1.62.09-3-.71-3-1.8s1.2-2,2.81-2.13,3,.71,3,1.79S283.58,103.3,282,103.4Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282,103.4c-1.62.09-3-.71-3-1.8s1.2-2,2.81-2.13,3,.71,3,1.79S283.58,103.3,282,103.4Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M297.08,102.47c.84,1.38.77,3-.16,3.52s-2.36-.1-3.2-1.48-.76-3,.17-3.52S296.25,101.09,297.08,102.47Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M298.57,101.51c.83,1.38.76,3-.17,3.52s-2.36-.1-3.2-1.48-.76-3,.17-3.52S297.73,100.13,298.57,101.51Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.57,101.51c.83,1.38.76,3-.17,3.52s-2.36-.1-3.2-1.48-.76-3,.17-3.52S297.73,100.13,298.57,101.51Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M271.92,110.51a1.92,1.92,0,1,1,1.81-2A1.92,1.92,0,0,1,271.92,110.51Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M273,110.45a1.92,1.92,0,1,1,1.81-2A1.92,1.92,0,0,1,273,110.45Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273,110.45a1.92,1.92,0,1,1,1.81-2A1.92,1.92,0,0,1,273,110.45Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M289.74,122.28a2.37,2.37,0,1,1,3.33-.33A2.37,2.37,0,0,1,289.74,122.28Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M290.72,123.08a2.37,2.37,0,1,1,3.33-.33A2.36,2.36,0,0,1,290.72,123.08Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.72,123.08a2.37,2.37,0,1,1,3.33-.33A2.36,2.36,0,0,1,290.72,123.08Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M270.59,120.41a1.41,1.41,0,1,1,1.33-1.49A1.42,1.42,0,0,1,270.59,120.41Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M271.35,120.36a1.41,1.41,0,1,1,1.32-1.49A1.4,1.4,0,0,1,271.35,120.36Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.35,120.36a1.41,1.41,0,1,1,1.32-1.49A1.4,1.4,0,0,1,271.35,120.36Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M282.59,142.9c0-.44,1-.89,2.39-1a6.72,6.72,0,0,1,1.27,0c.73.08,1.24.29,1.26.58,0,.44-1,.9-2.39,1S282.63,143.35,282.59,142.9Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M286.14,141.88a7.85,7.85,0,0,0-2.43.24c-.06-.45-.12-1-.19-1.48a8.19,8.19,0,0,1,2.61.7Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M297,136.74c-.26-.36.43-1.29,1.55-2.08a6,6,0,0,1,1.09-.64c.67-.31,1.21-.38,1.38-.14s-.43,1.29-1.54,2.08S297.23,137.1,297,136.74Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M299.52,134.06a5.5,5.5,0,0,0-2,1.44,13.84,13.84,0,0,0-.88-1.18,7.61,7.61,0,0,1,2.57-.7Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M308.9,129.48c-.4-.19-.26-1.34.32-2.58a7.3,7.3,0,0,1,.64-1.09c.44-.6.88-.92,1.14-.8s.26,1.34-.32,2.58S309.3,129.67,308.9,129.48Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M309.8,125.9a8,8,0,0,0-1,2.22l-1.37-.58a8.16,8.16,0,0,1,1.92-1.9Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M311,114.25c-.44,0-.9-1-1-2.39a6.72,6.72,0,0,1,0-1.27c.07-.73.29-1.24.58-1.26s.9,1,1,2.38S311.45,114.21,311,114.25Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M310,110.7a5.42,5.42,0,0,0,.25,2.43c-.46,0-1,.09-1.47.17a7.88,7.88,0,0,1,.69-2.57Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M275.87,125.26c-1.47-.67-2.3-2-1.84-3s2-1.25,3.47-.57,2.29,2,1.84,3S277.33,125.93,275.87,125.26Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M276.7,126.06c-1.46-.67-2.29-2-1.84-3s2-1.24,3.48-.57,2.29,2,1.84,3S278.17,126.73,276.7,126.06Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.7,126.06c-1.46-.67-2.29-2-1.84-3s2-1.24,3.48-.57,2.29,2,1.84,3S278.17,126.73,276.7,126.06Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M284.65,115.86a2.92,2.92,0,1,1,2.75-3.09A2.92,2.92,0,0,1,284.65,115.86Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M286.35,115.76a2.92,2.92,0,1,1,2.75-3.09A2.93,2.93,0,0,1,286.35,115.76Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.35,115.76a2.92,2.92,0,1,1,2.75-3.09A2.93,2.93,0,0,1,286.35,115.76Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M269.12,124.35c-.21.14-.68-.11-1.32-.76a12.31,12.31,0,0,1-2.1-3.18,17.45,17.45,0,0,1-1-2.47,20.81,20.81,0,0,1-.64-3,19.86,19.86,0,0,1,.37-7,19.54,19.54,0,0,1,2.87-6.45,20.07,20.07,0,0,1,1.93-2.39,18.32,18.32,0,0,1,2-1.77,12.21,12.21,0,0,1,3.31-1.87c.86-.29,1.4-.3,1.52-.08.27.48-1.18,1.69-3,3.88-.46.54-.93,1.16-1.41,1.83a25.88,25.88,0,0,0-1.39,2.23,22.53,22.53,0,0,0-2.16,5.49,22.14,22.14,0,0,0-.57,5.88,25.86,25.86,0,0,0,.23,2.61q.18,1.23.42,2.28C268.83,122.31,269.58,124,269.12,124.35Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M283.42,94.63a1.78,1.78,0,1,1-3.54.37,1.78,1.78,0,1,1,3.54-.37Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "microscope"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "216.45 315.92 229.74 317.47 231.85 320.14 230.77 328.46 227.97 330.6 215.18 328.26 216.45 315.92",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.61,317.37a38.45,38.45,0,0,1-.64,6.4,40.37,40.37,0,0,1-1.16,6.34,39.77,39.77,0,0,1,.64-6.41A40.68,40.68,0,0,1,229.61,317.37Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.77,330.17a40.85,40.85,0,0,1,.77-6.47,39.06,39.06,0,0,1,1.28-6.39,40.85,40.85,0,0,1-.77,6.47A40.68,40.68,0,0,1,225.77,330.17Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.64,336.78c0,.76,8.51,12.91,8.51,12.91h7.77l3-2.18,1.32-7.53-9.29-12.06Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.23,340a12.61,12.61,0,0,1-1.83,1.38c-1.15.82-2.7,2-4.37,3.35-3.34,2.72-5.86,5.15-6,5a9,9,0,0,1,1.52-1.73c1-1,2.44-2.34,4.12-3.72a44.75,44.75,0,0,1,4.5-3.25A8.32,8.32,0,0,1,224.23,340Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.33,338.8c.07.15-3.09,1.64-6.41,4.35a58.75,58.75,0,0,0-5.53,5.4,7.17,7.17,0,0,1,1.27-1.91,27.27,27.27,0,0,1,3.93-3.9,29.21,29.21,0,0,1,4.63-3.05A7.86,7.86,0,0,1,223.33,338.8Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.56,
    y: 335.66,
    width: 14.28,
    height: 19.47,
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,352.94a49.62,49.62,0,0,1-7.12.26,49.53,49.53,0,0,1-7.11-.26,47.85,47.85,0,0,1,7.11-.26A47.93,47.93,0,0,1,203,352.94Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.12,351.18a47.74,47.74,0,0,1-7.11.26,47.74,47.74,0,0,1-7.11-.26,49.41,49.41,0,0,1,7.11-.26A49.41,49.41,0,0,1,203.12,351.18Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.5,330.19A19.61,19.61,0,0,0,217.16,316l-7.54,4.92Z",
    style: {
      fill: "#E6EEF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.3,409.16h19.21v-18.8h40.41a4.77,4.77,0,0,0,4.77-4.77h0a4.78,4.78,0,0,0-4.77-4.77H181.35v-6.45h42.51a4.64,4.64,0,0,0,4.63-4.63h0a4.63,4.63,0,0,0-4.63-4.63H153.57v7.29h-7.86Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.57,365.11c0,14.77,0,29.28,0,44.05",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.52,409.16c-.15,0-.25-9.86-.24-22s.14-22,.29-22,.25,9.86.23,22S153.66,409.16,153.52,409.16Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.45,365.75c.14,0,.26,5.57.26,12.43s-.12,12.43-.26,12.43-.26-5.57-.26-12.43S164.3,365.75,164.45,365.75Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.49,446.5A24.07,24.07,0,0,0,209,429.66h-63.9l-1.4,17.95Z",
    style: {
      fill: "#E6EEF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.52,404.12V331.61a5,5,0,0,1,3.9-4.91l60.06-17.09.59-23.79,35.91-.59L223.09,275l17.53,20h0L217.36,320.4l-71.3,22.12-1.18,104h83.44a3.68,3.68,0,0,1,3.67,3.68v13.59H111.52Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.43,
    y: 358.79,
    width: 38.77,
    height: 6.32,
    rx: 3.05,
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.15,365.11a7.35,7.35,0,0,0,.84-.18,3,3,0,0,0,1.78-1.52,3.13,3.13,0,0,0,.3-1.68,2.81,2.81,0,0,0-.77-1.84,2.9,2.9,0,0,0-2.05-.93h-2.74l-30,.08a2.81,2.81,0,0,0-2.76,2.38,3.19,3.19,0,0,0,.28,1.91,2.82,2.82,0,0,0,1.38,1.28,4.46,4.46,0,0,0,1.92.23h5.91l13.5.05,9.11.09,2.47,0a4.73,4.73,0,0,1,.86.06,5.65,5.65,0,0,1-.86.05l-2.47,0-9.11.08-13.5.06H186.3a5,5,0,0,1-2.13-.27,3.3,3.3,0,0,1-1.62-1.51,3.74,3.74,0,0,1-.34-2.23,3.32,3.32,0,0,1,3.27-2.82l30,.07,2.75,0a3.18,3.18,0,0,1,2.26,1.07,3.09,3.09,0,0,1,.8,2,3.3,3.3,0,0,1-.37,1.78A3.05,3.05,0,0,1,219,365,2.22,2.22,0,0,1,218.15,365.11Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.21,
    cy: 403.51,
    r: 18.61,
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.55,404.11a22.94,22.94,0,0,0-.42-2.5,10.32,10.32,0,0,0-3.78-5.57,10,10,0,0,0-4.27-1.87,10.17,10.17,0,0,0-5.31.46,10.14,10.14,0,0,0-4.69,3.52,10.08,10.08,0,0,0,0,11.92,9.45,9.45,0,0,0,2.13,2.15,9.65,9.65,0,0,0,2.56,1.38,10.11,10.11,0,0,0,9.58-1.41,10.37,10.37,0,0,0,3.78-5.58,22.51,22.51,0,0,0,.42-2.5,7.94,7.94,0,0,1-.23,2.55,10.31,10.31,0,0,1-3.74,5.82,10.45,10.45,0,0,1-4.42,2,10.58,10.58,0,0,1-5.56-.43,9.78,9.78,0,0,1-2.68-1.43,10.17,10.17,0,0,1-2.25-2.24,10.52,10.52,0,0,1,0-12.53,9.76,9.76,0,0,1,2.25-2.24,10.09,10.09,0,0,1,2.68-1.44,10.66,10.66,0,0,1,5.55-.43,10.35,10.35,0,0,1,4.42,2,10.23,10.23,0,0,1,3.75,5.81A7.94,7.94,0,0,1,138.55,404.11Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.41 277.73 238.75 300.94 246.21 293.31 225.02 270.71 217.41 277.73",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.92,257.11l-9.74,9.29a1.67,1.67,0,0,0-.06,2.35l8.28,8.79a1.67,1.67,0,0,0,2.39,0l9.86-9.74a1.67,1.67,0,0,0,0-2.37l-8.4-8.34A1.66,1.66,0,0,0,249.92,257.11Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,268.38c-.24.35-10.91,10.7-10.91,10.7l8.47,8.66,10.74-10.67Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.67,
    y: 463.77,
    width: 144.08,
    height: 5.5,
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.07,
    y: 414.45,
    width: 32.92,
    height: 15.21,
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.64,429.66a108.59,108.59,0,0,1,0-15,108.59,108.59,0,0,1,0,15Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.15,429.66a108.59,108.59,0,0,1,0-15,108.59,108.59,0,0,1,0,15Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.65,429.66a108.59,108.59,0,0,1,0-15,108.59,108.59,0,0,1,0,15Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.16,429.66a108.59,108.59,0,0,1,0-15,108.59,108.59,0,0,1,0,15Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.67,429.66a108.59,108.59,0,0,1,0-15,108.59,108.59,0,0,1,0,15Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.17,429.66a108.59,108.59,0,0,1,0-15,108.59,108.59,0,0,1,0,15Z",
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "samples",
    "data-motion": "float",
    "data-delay": 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.15,400.84l.66,59.08a6.17,6.17,0,0,0,6.15,5.94h0a6.16,6.16,0,0,0,6.17-6.34V401Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.15,400.84h3.38l9.6,0h.15V401c0,6.75.05,15.8.08,26.37,0,5.3,0,11,0,16.94,0,3,0,6,0,9.15v4.71c0,.79,0,1.59-.06,2.43a6.48,6.48,0,0,1-3.76,5,6.41,6.41,0,0,1-8.93-4.85,11.69,11.69,0,0,1-.09-1.85c0-.61,0-1.21,0-1.81,0-1.2,0-2.39,0-3.57q0-3.54-.06-6.91c-.07-9-.14-17.07-.19-23.88s-.07-12.22-.1-16c0-1.86,0-3.32,0-4.34,0-.47,0-.84,0-1.11s0-.38,0-.37a2.12,2.12,0,0,1,0,.4c0,.29,0,.67,0,1.16,0,1,.05,2.51.09,4.39.06,3.83.15,9.32.26,16.09s.21,14.83.34,23.77q0,3.36.09,6.87c0,1.17,0,2.35,0,3.54,0,.6,0,1.2,0,1.8a12.86,12.86,0,0,0,.09,1.78,6,6,0,0,0,4.65,4.84,6,6,0,0,0,3.57-.38,5.94,5.94,0,0,0,2.7-2.43,5.8,5.8,0,0,0,.75-2.16,20.2,20.2,0,0,0,.06-2.35v-4.71c0-3.12,0-6.17,0-9.16,0-6,0-11.64,0-16.94,0-10.57.06-19.62.09-26.37l.14.14-9.52-.18-2.55-.06-.67,0Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.82,431.13l.07,28.14a5.21,5.21,0,0,0,5.2,5h0a5.22,5.22,0,0,0,5.22-5.36l-.21-27.7Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.32,
    y: 396.61,
    width: 20.63,
    height: 12.67,
    rx: 2.19,
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.8,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.7,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.6,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.5,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.41,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.31,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.21,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.64,
    y: 417.16,
    width: 6.85,
    height: 30.56,
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.13,444.18a1.46,1.46,0,0,1-1.47-1.54,1.49,1.49,0,0,1,.5-1.17l.39.42a.91.91,0,0,0-.33.71.91.91,0,1,0,1.82,0,.88.88,0,0,0-.34-.71l.39-.42a1.56,1.56,0,0,1-1,2.71Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.13,441.27a1.56,1.56,0,1,1,1.47-1.55A1.47,1.47,0,0,1,382.13,441.27Zm0-2.44a.89.89,0,1,0,.91.89A.87.87,0,0,0,382.13,438.83Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.55,435.86l-.79.55v.6h.79v.66h-2.84v-1.23c0-.76.39-1.23,1-1.23a.92.92,0,0,1,.9.58l.91-.63Zm-2.31.62V437h1v-.53c0-.4-.18-.61-.49-.61S381.24,436.08,381.24,436.48Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.71,432l2.84,1.23v.65l-2.84,1.23v-.71l2-.87-2-.87Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.71,431.73v-.65h2.84v.65Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.71,430.4v-1.29a1.43,1.43,0,1,1,2.84,0v1.29Zm2.3-1.25a.88.88,0,1,0-1.76,0v.6H383Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.15,427.17V426h.51v1.15Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.71,424.64h2.84v.66h-2.31v.57h-.53Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.07,421.88a1.38,1.38,0,0,1,1.53,1.45,1.49,1.49,0,0,1-.2.79l-.48-.24a.9.9,0,0,0,.14-.53.75.75,0,0,0-.83-.8.94.94,0,0,1,.26.7.9.9,0,0,1-.88,1,1,1,0,0,1-.95-1.08C380.66,422.37,381.15,421.88,382.07,421.88Zm-.5.74a.49.49,0,1,0,.43.49A.44.44,0,0,0,381.57,422.62Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.84,400.84l.66,59.08a6.17,6.17,0,0,0,6.15,5.94h0a6.16,6.16,0,0,0,6.17-6.34V401Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.84,400.84h3.38l9.6,0H361V401c0,6.75,0,15.8.08,26.37,0,5.3,0,11,0,16.94,0,3,0,6,0,9.15v4.71c0,.79,0,1.59-.06,2.43a6.48,6.48,0,0,1-3.76,5,6.41,6.41,0,0,1-8.93-4.85,11.69,11.69,0,0,1-.09-1.85c0-.61,0-1.21,0-1.81,0-1.2,0-2.39,0-3.57q0-3.54-.06-6.91c-.07-9-.14-17.07-.19-23.88s-.08-12.22-.1-16c0-1.86,0-3.32,0-4.34,0-.47,0-.84,0-1.11s0-.38,0-.37a2.12,2.12,0,0,1,0,.4c0,.29,0,.67,0,1.16,0,1,.05,2.51.09,4.39.06,3.83.15,9.32.26,16.09s.21,14.83.34,23.77q0,3.36.09,6.87c0,1.17,0,2.35,0,3.54,0,.6,0,1.2,0,1.8a12.86,12.86,0,0,0,.09,1.78,6,6,0,0,0,4.65,4.84,6,6,0,0,0,3.57-.38,5.94,5.94,0,0,0,2.7-2.43,5.8,5.8,0,0,0,.75-2.16,20.2,20.2,0,0,0,.06-2.35v-4.71c0-3.12,0-6.17,0-9.16,0-6,0-11.64,0-16.94,0-10.57.06-19.62.09-26.37l.14.14-9.52-.18-2.55-.06-.67,0Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.51,431.13l.07,28.14a5.21,5.21,0,0,0,5.2,5h0a5.22,5.22,0,0,0,5.22-5.36l-.21-27.7Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.01,
    y: 396.61,
    width: 20.63,
    height: 12.67,
    rx: 2.19,
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.49,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.39,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.29,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.19,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.1,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.9,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.33,
    y: 417.16,
    width: 6.85,
    height: 30.56,
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.82,444.18a1.46,1.46,0,0,1-1.47-1.54,1.49,1.49,0,0,1,.5-1.17l.39.42a.91.91,0,0,0-.33.71.91.91,0,0,0,1.82,0,.91.91,0,0,0-.34-.71l.39-.42a1.56,1.56,0,0,1-1,2.71Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.82,441.27a1.56,1.56,0,1,1,1.47-1.55A1.47,1.47,0,0,1,354.82,441.27Zm0-2.44a.89.89,0,1,0,.91.89A.87.87,0,0,0,354.82,438.83Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.24,435.86l-.79.55v.6h.79v.66H353.4v-1.23c0-.76.39-1.23,1-1.23a.92.92,0,0,1,.9.58l.91-.63Zm-2.31.62V437h1v-.53c0-.4-.18-.61-.49-.61S353.93,436.08,353.93,436.48Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.4,432l2.84,1.23v.65l-2.84,1.23v-.71l2-.87-2-.87Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.4,431.73v-.65h2.84v.65Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.4,430.4v-1.29a1.43,1.43,0,1,1,2.84,0v1.29Zm2.3-1.25a.88.88,0,1,0-1.76,0v.6h1.76Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.84,427.17V426h.51v1.15Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.4,424.64h2.84v.66h-2.31v.57h-.53Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.76,421.88a1.38,1.38,0,0,1,1.53,1.45,1.49,1.49,0,0,1-.2.79l-.48-.24a.9.9,0,0,0,.14-.53.75.75,0,0,0-.83-.8.94.94,0,0,1,.26.7.9.9,0,0,1-.88,1,1,1,0,0,1-.95-1.08C353.35,422.37,353.84,421.88,354.76,421.88Zm-.5.74a.49.49,0,1,0,.43.49A.44.44,0,0,0,354.26,422.62Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,400.84l.66,59.08a6.17,6.17,0,0,0,6.15,5.94h0a6.16,6.16,0,0,0,6.17-6.34V401Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,400.84h3.38l9.6,0h.15V401c0,6.75.05,15.8.08,26.37,0,5.3,0,11,0,16.94,0,3,0,6,0,9.15v4.71a22.21,22.21,0,0,1-.06,2.43,6.48,6.48,0,0,1-3.76,5,6.41,6.41,0,0,1-8.93-4.85,13,13,0,0,1-.09-1.85c0-.61,0-1.21,0-1.81,0-1.2,0-2.39,0-3.57q0-3.54-.06-6.91c-.07-9-.14-17.07-.19-23.88s-.07-12.22-.1-16c0-1.86,0-3.32,0-4.34,0-.47,0-.84,0-1.11s0-.38,0-.37a2.12,2.12,0,0,1,0,.4c0,.29,0,.67,0,1.16,0,1,.05,2.51.09,4.39.06,3.83.15,9.32.26,16.09s.21,14.83.34,23.77q0,3.36.09,6.87c0,1.17,0,2.35,0,3.54,0,.6,0,1.2,0,1.8a12.86,12.86,0,0,0,.09,1.78,6,6,0,0,0,4.65,4.84,6,6,0,0,0,3.57-.38,5.94,5.94,0,0,0,2.7-2.43,5.8,5.8,0,0,0,.75-2.16,20.2,20.2,0,0,0,.06-2.35v-4.71c0-3.12,0-6.17,0-9.16,0-6,0-11.64,0-16.94,0-10.57.07-19.62.09-26.37l.14.14-9.52-.18-2.55-.06-.67,0Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.63,431.13l.07,28.14a5.21,5.21,0,0,0,5.2,5h0a5.22,5.22,0,0,0,5.22-5.36l-.21-27.7Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.13,
    y: 396.61,
    width: 20.63,
    height: 12.67,
    rx: 2.19,
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.61,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.51,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.41,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.31,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.22,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.12,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.45,
    y: 417.16,
    width: 6.85,
    height: 30.56,
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.94,444.18a1.46,1.46,0,0,1-1.47-1.54,1.49,1.49,0,0,1,.5-1.17l.39.42a.91.91,0,0,0-.33.71.91.91,0,0,0,1.82,0,.88.88,0,0,0-.34-.71l.39-.42a1.56,1.56,0,0,1-1,2.71Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.94,441.27a1.56,1.56,0,1,1,1.47-1.55A1.47,1.47,0,0,1,327.94,441.27Zm0-2.44a.89.89,0,1,0,.91.89A.87.87,0,0,0,327.94,438.83Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.36,435.86l-.79.55v.6h.79v.66h-2.84v-1.23c0-.76.39-1.23,1-1.23a.92.92,0,0,1,.9.58l.91-.63Zm-2.3.62V437h1v-.53c0-.4-.19-.61-.5-.61S327.06,436.08,327.06,436.48Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.52,432l2.84,1.23v.65l-2.84,1.23v-.71l2-.87-2-.87Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.52,431.73v-.65h2.84v.65Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.52,430.4v-1.29a1.43,1.43,0,1,1,2.84,0v1.29Zm2.3-1.25a.88.88,0,1,0-1.76,0v.6h1.76Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,427.17V426h.51v1.15Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.52,424.64h2.84v.66h-2.31v.57h-.53Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.88,421.88a1.38,1.38,0,0,1,1.53,1.45,1.49,1.49,0,0,1-.2.79l-.48-.24a.9.9,0,0,0,.14-.53.75.75,0,0,0-.82-.8,1,1,0,0,1,.25.7.9.9,0,0,1-.88,1,1,1,0,0,1-.95-1.08C326.47,422.37,327,421.88,327.88,421.88Zm-.5.74a.49.49,0,1,0,.43.49A.44.44,0,0,0,327.38,422.62Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.09,400.84l.65,59.08a6.17,6.17,0,0,0,6.15,5.94h0a6.16,6.16,0,0,0,6.17-6.34V401Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.09,400.84s.06,0,.2,0h3.17l9.61,0h.14V401c0,6.75.05,15.8.08,26.37,0,5.3,0,11,0,16.94,0,3,0,6,0,9.15v4.71a22.21,22.21,0,0,1-.06,2.43,6.48,6.48,0,0,1-3.76,5,6.41,6.41,0,0,1-8.93-4.85,13,13,0,0,1-.09-1.85c0-.61,0-1.21,0-1.81,0-1.2,0-2.39,0-3.57q0-3.54-.06-6.91c-.07-9-.14-17.07-.19-23.88s-.07-12.22-.1-16c0-1.86,0-3.32,0-4.34,0-.47,0-.84,0-1.11a1.39,1.39,0,0,1,0-.37s0,.14,0,.4,0,.67,0,1.16c0,1,.05,2.51.09,4.39.06,3.83.15,9.32.26,16.09s.21,14.83.34,23.77q0,3.36.09,6.87c0,1.17,0,2.35,0,3.54l0,1.8a10.36,10.36,0,0,0,.09,1.78,5.92,5.92,0,0,0,4.64,4.84,6,6,0,0,0,3.57-.38,5.94,5.94,0,0,0,2.7-2.43,5.8,5.8,0,0,0,.75-2.16,20.2,20.2,0,0,0,.06-2.35v-4.71q0-4.68,0-9.16c0-6,0-11.64,0-16.94,0-10.57.07-19.62.09-26.37l.14.14-9.52-.18-2.55-.06-.67,0Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.75,431.13l.07,28.14a5.21,5.21,0,0,0,5.2,5h0a5.22,5.22,0,0,0,5.22-5.36l-.21-27.7Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.25,
    y: 396.61,
    width: 20.63,
    height: 12.67,
    rx: 2.19,
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.73,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.63,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.53,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.44,409.13a72.7,72.7,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.34,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.24,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.14,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.57,
    y: 417.16,
    width: 6.85,
    height: 30.56,
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.06,444.18a1.56,1.56,0,0,1-1-2.71l.39.42a.91.91,0,0,0-.34.71.91.91,0,0,0,1.82,0,.88.88,0,0,0-.34-.71l.39-.42a1.56,1.56,0,0,1-1,2.71Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.06,441.27a1.56,1.56,0,1,1,1.47-1.55A1.47,1.47,0,0,1,301.06,441.27Zm0-2.44a.89.89,0,1,0,.91.89A.87.87,0,0,0,301.06,438.83Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.48,435.86l-.79.55v.6h.79v.66h-2.84v-1.23c0-.76.4-1.23,1-1.23a.92.92,0,0,1,.9.58l.91-.63Zm-2.3.62V437h1v-.53c0-.4-.19-.61-.5-.61S300.18,436.08,300.18,436.48Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.64,432l2.84,1.23v.65l-2.84,1.23v-.71l2-.87-2-.87Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.64,431.73v-.65h2.84v.65Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.64,430.4v-1.29a1.43,1.43,0,1,1,2.84,0v1.29Zm2.3-1.25a.88.88,0,1,0-1.76,0v.6h1.76Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.09,427.17V426h.5v1.15Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.64,424.64h2.84v.66h-2.31v.57h-.53Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,421.88a1.38,1.38,0,0,1,1.53,1.45,1.59,1.59,0,0,1-.19.79l-.49-.24a.91.91,0,0,0,.15-.53.75.75,0,0,0-.83-.8,1,1,0,0,1,.25.7.9.9,0,0,1-.88,1,1,1,0,0,1-1-1.08C299.59,422.37,300.08,421.88,301,421.88Zm-.49.74a.49.49,0,0,0,0,1,.42.42,0,0,0,.42-.48A.44.44,0,0,0,300.51,422.62Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.21,400.84l.65,59.08a6.17,6.17,0,0,0,6.15,5.94h0a6.16,6.16,0,0,0,6.17-6.34V401Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.21,400.84s.06,0,.2,0h3.17l9.61,0h.14V401c0,6.75.05,15.8.08,26.37,0,5.3,0,11,0,16.94,0,3,0,6,0,9.15v4.71a22.21,22.21,0,0,1-.06,2.43,6.48,6.48,0,0,1-3.76,5,6.41,6.41,0,0,1-8.93-4.85,13,13,0,0,1-.09-1.85c0-.61,0-1.21,0-1.81,0-1.2,0-2.39,0-3.57q0-3.54-.06-6.91c-.07-9-.14-17.07-.19-23.88s-.07-12.22-.1-16c0-1.86,0-3.32,0-4.34,0-.47,0-.84,0-1.11a1.39,1.39,0,0,1,0-.37s0,.14,0,.4,0,.67,0,1.16c0,1,.05,2.51.09,4.39.06,3.83.15,9.32.26,16.09s.22,14.83.34,23.77q0,3.36.09,6.87c0,1.17,0,2.35,0,3.54l0,1.8a10.36,10.36,0,0,0,.09,1.78,5.92,5.92,0,0,0,4.64,4.84,6,6,0,0,0,3.57-.38,5.94,5.94,0,0,0,2.7-2.43,5.8,5.8,0,0,0,.75-2.16,20.2,20.2,0,0,0,.06-2.35v-4.71q0-4.68,0-9.16c0-6,0-11.64,0-16.94,0-10.57.07-19.62.09-26.37l.14.14-9.52-.18-2.55-.06-.67,0Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.87,431.13l.07,28.14a5.21,5.21,0,0,0,5.2,5h0a5.22,5.22,0,0,0,5.22-5.36l-.21-27.7Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.37,
    y: 396.61,
    width: 20.63,
    height: 12.67,
    rx: 2.19,
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.85,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.75,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.65,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.56,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.46,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.36,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.26,409.13a75.49,75.49,0,0,1,0-12.52,75.49,75.49,0,0,1,0,12.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.69,
    y: 417.16,
    width: 6.85,
    height: 30.56,
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.18,444.18a1.56,1.56,0,0,1-1-2.71l.39.42a.91.91,0,0,0-.34.71.91.91,0,0,0,1.82,0,.91.91,0,0,0-.33-.71l.38-.42a1.56,1.56,0,0,1-1,2.71Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.18,441.27a1.56,1.56,0,1,1,1.47-1.55A1.47,1.47,0,0,1,274.18,441.27Zm0-2.44a.89.89,0,1,0,.91.89A.87.87,0,0,0,274.18,438.83Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.6,435.86l-.79.55v.6h.79v.66h-2.84v-1.23c0-.76.4-1.23,1-1.23a.92.92,0,0,1,.9.58l.91-.63Zm-2.3.62V437h1v-.53c0-.4-.19-.61-.5-.61S273.3,436.08,273.3,436.48Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.76,432l2.84,1.23v.65l-2.84,1.23v-.71l2-.87-2-.87Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.76,431.73v-.65h2.84v.65Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.76,430.4v-1.29a1.43,1.43,0,1,1,2.84,0v1.29Zm2.3-1.25a.88.88,0,1,0-1.76,0v.6h1.76Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.21,427.17V426h.5v1.15Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.76,424.64h2.84v.66h-2.31v.57h-.53Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.12,421.88a1.38,1.38,0,0,1,1.53,1.45,1.59,1.59,0,0,1-.19.79l-.49-.24a.91.91,0,0,0,.15-.53.75.75,0,0,0-.83-.8,1,1,0,0,1,.25.7.9.9,0,0,1-.88,1,1,1,0,0,1-1-1.08C272.71,422.37,273.2,421.88,274.12,421.88Zm-.49.74a.49.49,0,0,0,0,1,.42.42,0,0,0,.42-.48A.44.44,0,0,0,273.63,422.62Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.74,
    y: 415.14,
    width: 151.72,
    height: 4.03,
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.74,
    y: 465.49,
    width: 151.72,
    height: 4.03,
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.21,
    y: 417.16,
    width: 4.56,
    height: 50.34,
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.34,
    y: 417.16,
    width: 4.56,
    height: 50.34,
    style: {
      fill: "#3B5A76"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "desk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M714.4,469.27c0,.14-149.73.26-334.38.26s-334.42-.12-334.42-.26S195.29,469,380,469,714.4,469.12,714.4,469.27Z",
    style: {
      fill: "#17324A"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLab);
export default __webpack_public_path__ + "static/media/lab.ebcdfdd33e1214d69bc0ca88fdaec9e2.svg";
export { ForwardRef as ReactComponent };